// Auto-generated by scripts/generate-icons.ts
// Do not edit manually - run `npm run generate-icons`

export const icons = {
  'a-arrow-down': () => import('lucide-static/icons/a-arrow-down.svg?react'),
  'a-arrow-up': () => import('lucide-static/icons/a-arrow-up.svg?react'),
  'a-large-small': () => import('lucide-static/icons/a-large-small.svg?react'),
  accessibility: () => import('lucide-static/icons/accessibility.svg?react'),
  'activity-square': () => import('lucide-static/icons/activity-square.svg?react'),
  activity: () => import('lucide-static/icons/activity.svg?react'),
  'air-vent': () => import('lucide-static/icons/air-vent.svg?react'),
  airplay: () => import('lucide-static/icons/airplay.svg?react'),
  'alarm-check': () => import('lucide-static/icons/alarm-check.svg?react'),
  'alarm-clock-check': () => import('lucide-static/icons/alarm-clock-check.svg?react'),
  'alarm-clock-minus': () => import('lucide-static/icons/alarm-clock-minus.svg?react'),
  'alarm-clock-off': () => import('lucide-static/icons/alarm-clock-off.svg?react'),
  'alarm-clock-plus': () => import('lucide-static/icons/alarm-clock-plus.svg?react'),
  'alarm-clock': () => import('lucide-static/icons/alarm-clock.svg?react'),
  'alarm-minus': () => import('lucide-static/icons/alarm-minus.svg?react'),
  'alarm-plus': () => import('lucide-static/icons/alarm-plus.svg?react'),
  'alarm-smoke': () => import('lucide-static/icons/alarm-smoke.svg?react'),
  album: () => import('lucide-static/icons/album.svg?react'),
  'alert-circle': () => import('lucide-static/icons/alert-circle.svg?react'),
  'alert-octagon': () => import('lucide-static/icons/alert-octagon.svg?react'),
  'alert-triangle': () => import('lucide-static/icons/alert-triangle.svg?react'),
  'align-center-horizontal': () => import('lucide-static/icons/align-center-horizontal.svg?react'),
  'align-center-vertical': () => import('lucide-static/icons/align-center-vertical.svg?react'),
  'align-center': () => import('lucide-static/icons/align-center.svg?react'),
  'align-end-horizontal': () => import('lucide-static/icons/align-end-horizontal.svg?react'),
  'align-end-vertical': () => import('lucide-static/icons/align-end-vertical.svg?react'),
  'align-horizontal-distribute-center': () =>
    import('lucide-static/icons/align-horizontal-distribute-center.svg?react'),
  'align-horizontal-distribute-end': () =>
    import('lucide-static/icons/align-horizontal-distribute-end.svg?react'),
  'align-horizontal-distribute-start': () =>
    import('lucide-static/icons/align-horizontal-distribute-start.svg?react'),
  'align-horizontal-justify-center': () =>
    import('lucide-static/icons/align-horizontal-justify-center.svg?react'),
  'align-horizontal-justify-end': () =>
    import('lucide-static/icons/align-horizontal-justify-end.svg?react'),
  'align-horizontal-justify-start': () =>
    import('lucide-static/icons/align-horizontal-justify-start.svg?react'),
  'align-horizontal-space-around': () =>
    import('lucide-static/icons/align-horizontal-space-around.svg?react'),
  'align-horizontal-space-between': () =>
    import('lucide-static/icons/align-horizontal-space-between.svg?react'),
  'align-justify': () => import('lucide-static/icons/align-justify.svg?react'),
  'align-left': () => import('lucide-static/icons/align-left.svg?react'),
  'align-right': () => import('lucide-static/icons/align-right.svg?react'),
  'align-start-horizontal': () => import('lucide-static/icons/align-start-horizontal.svg?react'),
  'align-start-vertical': () => import('lucide-static/icons/align-start-vertical.svg?react'),
  'align-vertical-distribute-center': () =>
    import('lucide-static/icons/align-vertical-distribute-center.svg?react'),
  'align-vertical-distribute-end': () =>
    import('lucide-static/icons/align-vertical-distribute-end.svg?react'),
  'align-vertical-distribute-start': () =>
    import('lucide-static/icons/align-vertical-distribute-start.svg?react'),
  'align-vertical-justify-center': () =>
    import('lucide-static/icons/align-vertical-justify-center.svg?react'),
  'align-vertical-justify-end': () =>
    import('lucide-static/icons/align-vertical-justify-end.svg?react'),
  'align-vertical-justify-start': () =>
    import('lucide-static/icons/align-vertical-justify-start.svg?react'),
  'align-vertical-space-around': () =>
    import('lucide-static/icons/align-vertical-space-around.svg?react'),
  'align-vertical-space-between': () =>
    import('lucide-static/icons/align-vertical-space-between.svg?react'),
  ambulance: () => import('lucide-static/icons/ambulance.svg?react'),
  ampersand: () => import('lucide-static/icons/ampersand.svg?react'),
  ampersands: () => import('lucide-static/icons/ampersands.svg?react'),
  amphora: () => import('lucide-static/icons/amphora.svg?react'),
  anchor: () => import('lucide-static/icons/anchor.svg?react'),
  angry: () => import('lucide-static/icons/angry.svg?react'),
  annoyed: () => import('lucide-static/icons/annoyed.svg?react'),
  antenna: () => import('lucide-static/icons/antenna.svg?react'),
  anvil: () => import('lucide-static/icons/anvil.svg?react'),
  aperture: () => import('lucide-static/icons/aperture.svg?react'),
  'app-window-mac': () => import('lucide-static/icons/app-window-mac.svg?react'),
  'app-window': () => import('lucide-static/icons/app-window.svg?react'),
  apple: () => import('lucide-static/icons/apple.svg?react'),
  'archive-restore': () => import('lucide-static/icons/archive-restore.svg?react'),
  'archive-x': () => import('lucide-static/icons/archive-x.svg?react'),
  archive: () => import('lucide-static/icons/archive.svg?react'),
  'area-chart': () => import('lucide-static/icons/area-chart.svg?react'),
  armchair: () => import('lucide-static/icons/armchair.svg?react'),
  'arrow-big-down-dash': () => import('lucide-static/icons/arrow-big-down-dash.svg?react'),
  'arrow-big-down': () => import('lucide-static/icons/arrow-big-down.svg?react'),
  'arrow-big-left-dash': () => import('lucide-static/icons/arrow-big-left-dash.svg?react'),
  'arrow-big-left': () => import('lucide-static/icons/arrow-big-left.svg?react'),
  'arrow-big-right-dash': () => import('lucide-static/icons/arrow-big-right-dash.svg?react'),
  'arrow-big-right': () => import('lucide-static/icons/arrow-big-right.svg?react'),
  'arrow-big-up-dash': () => import('lucide-static/icons/arrow-big-up-dash.svg?react'),
  'arrow-big-up': () => import('lucide-static/icons/arrow-big-up.svg?react'),
  'arrow-down-0-1': () => import('lucide-static/icons/arrow-down-0-1.svg?react'),
  'arrow-down-01': () => import('lucide-static/icons/arrow-down-01.svg?react'),
  'arrow-down-1-0': () => import('lucide-static/icons/arrow-down-1-0.svg?react'),
  'arrow-down-10': () => import('lucide-static/icons/arrow-down-10.svg?react'),
  'arrow-down-a-z': () => import('lucide-static/icons/arrow-down-a-z.svg?react'),
  'arrow-down-az': () => import('lucide-static/icons/arrow-down-az.svg?react'),
  'arrow-down-circle': () => import('lucide-static/icons/arrow-down-circle.svg?react'),
  'arrow-down-from-line': () => import('lucide-static/icons/arrow-down-from-line.svg?react'),
  'arrow-down-left-from-circle': () =>
    import('lucide-static/icons/arrow-down-left-from-circle.svg?react'),
  'arrow-down-left-from-square': () =>
    import('lucide-static/icons/arrow-down-left-from-square.svg?react'),
  'arrow-down-left-square': () => import('lucide-static/icons/arrow-down-left-square.svg?react'),
  'arrow-down-left': () => import('lucide-static/icons/arrow-down-left.svg?react'),
  'arrow-down-narrow-wide': () => import('lucide-static/icons/arrow-down-narrow-wide.svg?react'),
  'arrow-down-right-from-circle': () =>
    import('lucide-static/icons/arrow-down-right-from-circle.svg?react'),
  'arrow-down-right-from-square': () =>
    import('lucide-static/icons/arrow-down-right-from-square.svg?react'),
  'arrow-down-right-square': () => import('lucide-static/icons/arrow-down-right-square.svg?react'),
  'arrow-down-right': () => import('lucide-static/icons/arrow-down-right.svg?react'),
  'arrow-down-square': () => import('lucide-static/icons/arrow-down-square.svg?react'),
  'arrow-down-to-dot': () => import('lucide-static/icons/arrow-down-to-dot.svg?react'),
  'arrow-down-to-line': () => import('lucide-static/icons/arrow-down-to-line.svg?react'),
  'arrow-down-up': () => import('lucide-static/icons/arrow-down-up.svg?react'),
  'arrow-down-wide-narrow': () => import('lucide-static/icons/arrow-down-wide-narrow.svg?react'),
  'arrow-down-z-a': () => import('lucide-static/icons/arrow-down-z-a.svg?react'),
  'arrow-down-za': () => import('lucide-static/icons/arrow-down-za.svg?react'),
  'arrow-down': () => import('lucide-static/icons/arrow-down.svg?react'),
  'arrow-left-circle': () => import('lucide-static/icons/arrow-left-circle.svg?react'),
  'arrow-left-from-line': () => import('lucide-static/icons/arrow-left-from-line.svg?react'),
  'arrow-left-right': () => import('lucide-static/icons/arrow-left-right.svg?react'),
  'arrow-left-square': () => import('lucide-static/icons/arrow-left-square.svg?react'),
  'arrow-left-to-line': () => import('lucide-static/icons/arrow-left-to-line.svg?react'),
  'arrow-left': () => import('lucide-static/icons/arrow-left.svg?react'),
  'arrow-right-circle': () => import('lucide-static/icons/arrow-right-circle.svg?react'),
  'arrow-right-from-line': () => import('lucide-static/icons/arrow-right-from-line.svg?react'),
  'arrow-right-left': () => import('lucide-static/icons/arrow-right-left.svg?react'),
  'arrow-right-square': () => import('lucide-static/icons/arrow-right-square.svg?react'),
  'arrow-right-to-line': () => import('lucide-static/icons/arrow-right-to-line.svg?react'),
  'arrow-right': () => import('lucide-static/icons/arrow-right.svg?react'),
  'arrow-up-0-1': () => import('lucide-static/icons/arrow-up-0-1.svg?react'),
  'arrow-up-01': () => import('lucide-static/icons/arrow-up-01.svg?react'),
  'arrow-up-1-0': () => import('lucide-static/icons/arrow-up-1-0.svg?react'),
  'arrow-up-10': () => import('lucide-static/icons/arrow-up-10.svg?react'),
  'arrow-up-a-z': () => import('lucide-static/icons/arrow-up-a-z.svg?react'),
  'arrow-up-az': () => import('lucide-static/icons/arrow-up-az.svg?react'),
  'arrow-up-circle': () => import('lucide-static/icons/arrow-up-circle.svg?react'),
  'arrow-up-down': () => import('lucide-static/icons/arrow-up-down.svg?react'),
  'arrow-up-from-dot': () => import('lucide-static/icons/arrow-up-from-dot.svg?react'),
  'arrow-up-from-line': () => import('lucide-static/icons/arrow-up-from-line.svg?react'),
  'arrow-up-left-from-circle': () =>
    import('lucide-static/icons/arrow-up-left-from-circle.svg?react'),
  'arrow-up-left-from-square': () =>
    import('lucide-static/icons/arrow-up-left-from-square.svg?react'),
  'arrow-up-left-square': () => import('lucide-static/icons/arrow-up-left-square.svg?react'),
  'arrow-up-left': () => import('lucide-static/icons/arrow-up-left.svg?react'),
  'arrow-up-narrow-wide': () => import('lucide-static/icons/arrow-up-narrow-wide.svg?react'),
  'arrow-up-right-from-circle': () =>
    import('lucide-static/icons/arrow-up-right-from-circle.svg?react'),
  'arrow-up-right-from-square': () =>
    import('lucide-static/icons/arrow-up-right-from-square.svg?react'),
  'arrow-up-right-square': () => import('lucide-static/icons/arrow-up-right-square.svg?react'),
  'arrow-up-right': () => import('lucide-static/icons/arrow-up-right.svg?react'),
  'arrow-up-square': () => import('lucide-static/icons/arrow-up-square.svg?react'),
  'arrow-up-to-line': () => import('lucide-static/icons/arrow-up-to-line.svg?react'),
  'arrow-up-wide-narrow': () => import('lucide-static/icons/arrow-up-wide-narrow.svg?react'),
  'arrow-up-z-a': () => import('lucide-static/icons/arrow-up-z-a.svg?react'),
  'arrow-up-za': () => import('lucide-static/icons/arrow-up-za.svg?react'),
  'arrow-up': () => import('lucide-static/icons/arrow-up.svg?react'),
  'arrows-up-from-line': () => import('lucide-static/icons/arrows-up-from-line.svg?react'),
  'asterisk-square': () => import('lucide-static/icons/asterisk-square.svg?react'),
  asterisk: () => import('lucide-static/icons/asterisk.svg?react'),
  'at-sign': () => import('lucide-static/icons/at-sign.svg?react'),
  atom: () => import('lucide-static/icons/atom.svg?react'),
  'audio-lines': () => import('lucide-static/icons/audio-lines.svg?react'),
  'audio-waveform': () => import('lucide-static/icons/audio-waveform.svg?react'),
  award: () => import('lucide-static/icons/award.svg?react'),
  axe: () => import('lucide-static/icons/axe.svg?react'),
  'axis-3-d': () => import('lucide-static/icons/axis-3-d.svg?react'),
  'axis-3d': () => import('lucide-static/icons/axis-3d.svg?react'),
  baby: () => import('lucide-static/icons/baby.svg?react'),
  backpack: () => import('lucide-static/icons/backpack.svg?react'),
  'badge-alert': () => import('lucide-static/icons/badge-alert.svg?react'),
  'badge-cent': () => import('lucide-static/icons/badge-cent.svg?react'),
  'badge-check': () => import('lucide-static/icons/badge-check.svg?react'),
  'badge-dollar-sign': () => import('lucide-static/icons/badge-dollar-sign.svg?react'),
  'badge-euro': () => import('lucide-static/icons/badge-euro.svg?react'),
  'badge-help': () => import('lucide-static/icons/badge-help.svg?react'),
  'badge-indian-rupee': () => import('lucide-static/icons/badge-indian-rupee.svg?react'),
  'badge-info': () => import('lucide-static/icons/badge-info.svg?react'),
  'badge-japanese-yen': () => import('lucide-static/icons/badge-japanese-yen.svg?react'),
  'badge-minus': () => import('lucide-static/icons/badge-minus.svg?react'),
  'badge-percent': () => import('lucide-static/icons/badge-percent.svg?react'),
  'badge-plus': () => import('lucide-static/icons/badge-plus.svg?react'),
  'badge-pound-sterling': () => import('lucide-static/icons/badge-pound-sterling.svg?react'),
  'badge-question-mark': () => import('lucide-static/icons/badge-question-mark.svg?react'),
  'badge-russian-ruble': () => import('lucide-static/icons/badge-russian-ruble.svg?react'),
  'badge-swiss-franc': () => import('lucide-static/icons/badge-swiss-franc.svg?react'),
  'badge-turkish-lira': () => import('lucide-static/icons/badge-turkish-lira.svg?react'),
  'badge-x': () => import('lucide-static/icons/badge-x.svg?react'),
  badge: () => import('lucide-static/icons/badge.svg?react'),
  'baggage-claim': () => import('lucide-static/icons/baggage-claim.svg?react'),
  balloon: () => import('lucide-static/icons/balloon.svg?react'),
  ban: () => import('lucide-static/icons/ban.svg?react'),
  banana: () => import('lucide-static/icons/banana.svg?react'),
  bandage: () => import('lucide-static/icons/bandage.svg?react'),
  'banknote-arrow-down': () => import('lucide-static/icons/banknote-arrow-down.svg?react'),
  'banknote-arrow-up': () => import('lucide-static/icons/banknote-arrow-up.svg?react'),
  'banknote-x': () => import('lucide-static/icons/banknote-x.svg?react'),
  banknote: () => import('lucide-static/icons/banknote.svg?react'),
  'bar-chart-2': () => import('lucide-static/icons/bar-chart-2.svg?react'),
  'bar-chart-3': () => import('lucide-static/icons/bar-chart-3.svg?react'),
  'bar-chart-4': () => import('lucide-static/icons/bar-chart-4.svg?react'),
  'bar-chart-big': () => import('lucide-static/icons/bar-chart-big.svg?react'),
  'bar-chart-horizontal-big': () =>
    import('lucide-static/icons/bar-chart-horizontal-big.svg?react'),
  'bar-chart-horizontal': () => import('lucide-static/icons/bar-chart-horizontal.svg?react'),
  'bar-chart': () => import('lucide-static/icons/bar-chart.svg?react'),
  barcode: () => import('lucide-static/icons/barcode.svg?react'),
  barrel: () => import('lucide-static/icons/barrel.svg?react'),
  baseline: () => import('lucide-static/icons/baseline.svg?react'),
  bath: () => import('lucide-static/icons/bath.svg?react'),
  'battery-charging': () => import('lucide-static/icons/battery-charging.svg?react'),
  'battery-full': () => import('lucide-static/icons/battery-full.svg?react'),
  'battery-low': () => import('lucide-static/icons/battery-low.svg?react'),
  'battery-medium': () => import('lucide-static/icons/battery-medium.svg?react'),
  'battery-plus': () => import('lucide-static/icons/battery-plus.svg?react'),
  'battery-warning': () => import('lucide-static/icons/battery-warning.svg?react'),
  battery: () => import('lucide-static/icons/battery.svg?react'),
  beaker: () => import('lucide-static/icons/beaker.svg?react'),
  'bean-off': () => import('lucide-static/icons/bean-off.svg?react'),
  bean: () => import('lucide-static/icons/bean.svg?react'),
  'bed-double': () => import('lucide-static/icons/bed-double.svg?react'),
  'bed-single': () => import('lucide-static/icons/bed-single.svg?react'),
  bed: () => import('lucide-static/icons/bed.svg?react'),
  beef: () => import('lucide-static/icons/beef.svg?react'),
  'beer-off': () => import('lucide-static/icons/beer-off.svg?react'),
  beer: () => import('lucide-static/icons/beer.svg?react'),
  'bell-dot': () => import('lucide-static/icons/bell-dot.svg?react'),
  'bell-electric': () => import('lucide-static/icons/bell-electric.svg?react'),
  'bell-minus': () => import('lucide-static/icons/bell-minus.svg?react'),
  'bell-off': () => import('lucide-static/icons/bell-off.svg?react'),
  'bell-plus': () => import('lucide-static/icons/bell-plus.svg?react'),
  'bell-ring': () => import('lucide-static/icons/bell-ring.svg?react'),
  bell: () => import('lucide-static/icons/bell.svg?react'),
  'between-horizonal-end': () => import('lucide-static/icons/between-horizonal-end.svg?react'),
  'between-horizonal-start': () => import('lucide-static/icons/between-horizonal-start.svg?react'),
  'between-horizontal-end': () => import('lucide-static/icons/between-horizontal-end.svg?react'),
  'between-horizontal-start': () =>
    import('lucide-static/icons/between-horizontal-start.svg?react'),
  'between-vertical-end': () => import('lucide-static/icons/between-vertical-end.svg?react'),
  'between-vertical-start': () => import('lucide-static/icons/between-vertical-start.svg?react'),
  'biceps-flexed': () => import('lucide-static/icons/biceps-flexed.svg?react'),
  bike: () => import('lucide-static/icons/bike.svg?react'),
  binary: () => import('lucide-static/icons/binary.svg?react'),
  binoculars: () => import('lucide-static/icons/binoculars.svg?react'),
  biohazard: () => import('lucide-static/icons/biohazard.svg?react'),
  bird: () => import('lucide-static/icons/bird.svg?react'),
  birdhouse: () => import('lucide-static/icons/birdhouse.svg?react'),
  bitcoin: () => import('lucide-static/icons/bitcoin.svg?react'),
  blend: () => import('lucide-static/icons/blend.svg?react'),
  blinds: () => import('lucide-static/icons/blinds.svg?react'),
  blocks: () => import('lucide-static/icons/blocks.svg?react'),
  'bluetooth-connected': () => import('lucide-static/icons/bluetooth-connected.svg?react'),
  'bluetooth-off': () => import('lucide-static/icons/bluetooth-off.svg?react'),
  'bluetooth-searching': () => import('lucide-static/icons/bluetooth-searching.svg?react'),
  bluetooth: () => import('lucide-static/icons/bluetooth.svg?react'),
  bold: () => import('lucide-static/icons/bold.svg?react'),
  bolt: () => import('lucide-static/icons/bolt.svg?react'),
  bomb: () => import('lucide-static/icons/bomb.svg?react'),
  bone: () => import('lucide-static/icons/bone.svg?react'),
  'book-a': () => import('lucide-static/icons/book-a.svg?react'),
  'book-alert': () => import('lucide-static/icons/book-alert.svg?react'),
  'book-audio': () => import('lucide-static/icons/book-audio.svg?react'),
  'book-check': () => import('lucide-static/icons/book-check.svg?react'),
  'book-copy': () => import('lucide-static/icons/book-copy.svg?react'),
  'book-dashed': () => import('lucide-static/icons/book-dashed.svg?react'),
  'book-down': () => import('lucide-static/icons/book-down.svg?react'),
  'book-headphones': () => import('lucide-static/icons/book-headphones.svg?react'),
  'book-heart': () => import('lucide-static/icons/book-heart.svg?react'),
  'book-image': () => import('lucide-static/icons/book-image.svg?react'),
  'book-key': () => import('lucide-static/icons/book-key.svg?react'),
  'book-lock': () => import('lucide-static/icons/book-lock.svg?react'),
  'book-marked': () => import('lucide-static/icons/book-marked.svg?react'),
  'book-minus': () => import('lucide-static/icons/book-minus.svg?react'),
  'book-open-check': () => import('lucide-static/icons/book-open-check.svg?react'),
  'book-open-text': () => import('lucide-static/icons/book-open-text.svg?react'),
  'book-open': () => import('lucide-static/icons/book-open.svg?react'),
  'book-plus': () => import('lucide-static/icons/book-plus.svg?react'),
  'book-search': () => import('lucide-static/icons/book-search.svg?react'),
  'book-template': () => import('lucide-static/icons/book-template.svg?react'),
  'book-text': () => import('lucide-static/icons/book-text.svg?react'),
  'book-type': () => import('lucide-static/icons/book-type.svg?react'),
  'book-up-2': () => import('lucide-static/icons/book-up-2.svg?react'),
  'book-up': () => import('lucide-static/icons/book-up.svg?react'),
  'book-user': () => import('lucide-static/icons/book-user.svg?react'),
  'book-x': () => import('lucide-static/icons/book-x.svg?react'),
  book: () => import('lucide-static/icons/book.svg?react'),
  'bookmark-check': () => import('lucide-static/icons/bookmark-check.svg?react'),
  'bookmark-minus': () => import('lucide-static/icons/bookmark-minus.svg?react'),
  'bookmark-plus': () => import('lucide-static/icons/bookmark-plus.svg?react'),
  'bookmark-x': () => import('lucide-static/icons/bookmark-x.svg?react'),
  bookmark: () => import('lucide-static/icons/bookmark.svg?react'),
  'boom-box': () => import('lucide-static/icons/boom-box.svg?react'),
  'bot-message-square': () => import('lucide-static/icons/bot-message-square.svg?react'),
  'bot-off': () => import('lucide-static/icons/bot-off.svg?react'),
  bot: () => import('lucide-static/icons/bot.svg?react'),
  'bottle-wine': () => import('lucide-static/icons/bottle-wine.svg?react'),
  'bow-arrow': () => import('lucide-static/icons/bow-arrow.svg?react'),
  'box-select': () => import('lucide-static/icons/box-select.svg?react'),
  box: () => import('lucide-static/icons/box.svg?react'),
  boxes: () => import('lucide-static/icons/boxes.svg?react'),
  braces: () => import('lucide-static/icons/braces.svg?react'),
  brackets: () => import('lucide-static/icons/brackets.svg?react'),
  'brain-circuit': () => import('lucide-static/icons/brain-circuit.svg?react'),
  'brain-cog': () => import('lucide-static/icons/brain-cog.svg?react'),
  brain: () => import('lucide-static/icons/brain.svg?react'),
  'brick-wall-fire': () => import('lucide-static/icons/brick-wall-fire.svg?react'),
  'brick-wall-shield': () => import('lucide-static/icons/brick-wall-shield.svg?react'),
  'brick-wall': () => import('lucide-static/icons/brick-wall.svg?react'),
  'briefcase-business': () => import('lucide-static/icons/briefcase-business.svg?react'),
  'briefcase-conveyor-belt': () => import('lucide-static/icons/briefcase-conveyor-belt.svg?react'),
  'briefcase-medical': () => import('lucide-static/icons/briefcase-medical.svg?react'),
  briefcase: () => import('lucide-static/icons/briefcase.svg?react'),
  'bring-to-front': () => import('lucide-static/icons/bring-to-front.svg?react'),
  'brush-cleaning': () => import('lucide-static/icons/brush-cleaning.svg?react'),
  brush: () => import('lucide-static/icons/brush.svg?react'),
  bubbles: () => import('lucide-static/icons/bubbles.svg?react'),
  'bug-off': () => import('lucide-static/icons/bug-off.svg?react'),
  'bug-play': () => import('lucide-static/icons/bug-play.svg?react'),
  bug: () => import('lucide-static/icons/bug.svg?react'),
  'building-2': () => import('lucide-static/icons/building-2.svg?react'),
  building: () => import('lucide-static/icons/building.svg?react'),
  'bus-front': () => import('lucide-static/icons/bus-front.svg?react'),
  bus: () => import('lucide-static/icons/bus.svg?react'),
  'cable-car': () => import('lucide-static/icons/cable-car.svg?react'),
  cable: () => import('lucide-static/icons/cable.svg?react'),
  'cake-slice': () => import('lucide-static/icons/cake-slice.svg?react'),
  cake: () => import('lucide-static/icons/cake.svg?react'),
  calculator: () => import('lucide-static/icons/calculator.svg?react'),
  'calendar-1': () => import('lucide-static/icons/calendar-1.svg?react'),
  'calendar-arrow-down': () => import('lucide-static/icons/calendar-arrow-down.svg?react'),
  'calendar-arrow-up': () => import('lucide-static/icons/calendar-arrow-up.svg?react'),
  'calendar-check-2': () => import('lucide-static/icons/calendar-check-2.svg?react'),
  'calendar-check': () => import('lucide-static/icons/calendar-check.svg?react'),
  'calendar-clock': () => import('lucide-static/icons/calendar-clock.svg?react'),
  'calendar-cog': () => import('lucide-static/icons/calendar-cog.svg?react'),
  'calendar-days': () => import('lucide-static/icons/calendar-days.svg?react'),
  'calendar-fold': () => import('lucide-static/icons/calendar-fold.svg?react'),
  'calendar-heart': () => import('lucide-static/icons/calendar-heart.svg?react'),
  'calendar-minus-2': () => import('lucide-static/icons/calendar-minus-2.svg?react'),
  'calendar-minus': () => import('lucide-static/icons/calendar-minus.svg?react'),
  'calendar-off': () => import('lucide-static/icons/calendar-off.svg?react'),
  'calendar-plus-2': () => import('lucide-static/icons/calendar-plus-2.svg?react'),
  'calendar-plus': () => import('lucide-static/icons/calendar-plus.svg?react'),
  'calendar-range': () => import('lucide-static/icons/calendar-range.svg?react'),
  'calendar-search': () => import('lucide-static/icons/calendar-search.svg?react'),
  'calendar-sync': () => import('lucide-static/icons/calendar-sync.svg?react'),
  'calendar-x-2': () => import('lucide-static/icons/calendar-x-2.svg?react'),
  'calendar-x': () => import('lucide-static/icons/calendar-x.svg?react'),
  calendar: () => import('lucide-static/icons/calendar.svg?react'),
  calendars: () => import('lucide-static/icons/calendars.svg?react'),
  'camera-off': () => import('lucide-static/icons/camera-off.svg?react'),
  camera: () => import('lucide-static/icons/camera.svg?react'),
  'candlestick-chart': () => import('lucide-static/icons/candlestick-chart.svg?react'),
  'candy-cane': () => import('lucide-static/icons/candy-cane.svg?react'),
  'candy-off': () => import('lucide-static/icons/candy-off.svg?react'),
  candy: () => import('lucide-static/icons/candy.svg?react'),
  'cannabis-off': () => import('lucide-static/icons/cannabis-off.svg?react'),
  cannabis: () => import('lucide-static/icons/cannabis.svg?react'),
  'captions-off': () => import('lucide-static/icons/captions-off.svg?react'),
  captions: () => import('lucide-static/icons/captions.svg?react'),
  'car-front': () => import('lucide-static/icons/car-front.svg?react'),
  'car-taxi-front': () => import('lucide-static/icons/car-taxi-front.svg?react'),
  car: () => import('lucide-static/icons/car.svg?react'),
  caravan: () => import('lucide-static/icons/caravan.svg?react'),
  'card-sim': () => import('lucide-static/icons/card-sim.svg?react'),
  carrot: () => import('lucide-static/icons/carrot.svg?react'),
  'case-lower': () => import('lucide-static/icons/case-lower.svg?react'),
  'case-sensitive': () => import('lucide-static/icons/case-sensitive.svg?react'),
  'case-upper': () => import('lucide-static/icons/case-upper.svg?react'),
  'cassette-tape': () => import('lucide-static/icons/cassette-tape.svg?react'),
  cast: () => import('lucide-static/icons/cast.svg?react'),
  castle: () => import('lucide-static/icons/castle.svg?react'),
  cat: () => import('lucide-static/icons/cat.svg?react'),
  cctv: () => import('lucide-static/icons/cctv.svg?react'),
  'chart-area': () => import('lucide-static/icons/chart-area.svg?react'),
  'chart-bar-big': () => import('lucide-static/icons/chart-bar-big.svg?react'),
  'chart-bar-decreasing': () => import('lucide-static/icons/chart-bar-decreasing.svg?react'),
  'chart-bar-increasing': () => import('lucide-static/icons/chart-bar-increasing.svg?react'),
  'chart-bar-stacked': () => import('lucide-static/icons/chart-bar-stacked.svg?react'),
  'chart-bar': () => import('lucide-static/icons/chart-bar.svg?react'),
  'chart-candlestick': () => import('lucide-static/icons/chart-candlestick.svg?react'),
  'chart-column-big': () => import('lucide-static/icons/chart-column-big.svg?react'),
  'chart-column-decreasing': () => import('lucide-static/icons/chart-column-decreasing.svg?react'),
  'chart-column-increasing': () => import('lucide-static/icons/chart-column-increasing.svg?react'),
  'chart-column-stacked': () => import('lucide-static/icons/chart-column-stacked.svg?react'),
  'chart-column': () => import('lucide-static/icons/chart-column.svg?react'),
  'chart-gantt': () => import('lucide-static/icons/chart-gantt.svg?react'),
  'chart-line': () => import('lucide-static/icons/chart-line.svg?react'),
  'chart-network': () => import('lucide-static/icons/chart-network.svg?react'),
  'chart-no-axes-column-decreasing': () =>
    import('lucide-static/icons/chart-no-axes-column-decreasing.svg?react'),
  'chart-no-axes-column-increasing': () =>
    import('lucide-static/icons/chart-no-axes-column-increasing.svg?react'),
  'chart-no-axes-column': () => import('lucide-static/icons/chart-no-axes-column.svg?react'),
  'chart-no-axes-combined': () => import('lucide-static/icons/chart-no-axes-combined.svg?react'),
  'chart-no-axes-gantt': () => import('lucide-static/icons/chart-no-axes-gantt.svg?react'),
  'chart-pie': () => import('lucide-static/icons/chart-pie.svg?react'),
  'chart-scatter': () => import('lucide-static/icons/chart-scatter.svg?react'),
  'chart-spline': () => import('lucide-static/icons/chart-spline.svg?react'),
  'check-check': () => import('lucide-static/icons/check-check.svg?react'),
  'check-circle-2': () => import('lucide-static/icons/check-circle-2.svg?react'),
  'check-circle': () => import('lucide-static/icons/check-circle.svg?react'),
  'check-line': () => import('lucide-static/icons/check-line.svg?react'),
  'check-square-2': () => import('lucide-static/icons/check-square-2.svg?react'),
  'check-square': () => import('lucide-static/icons/check-square.svg?react'),
  check: () => import('lucide-static/icons/check.svg?react'),
  'chef-hat': () => import('lucide-static/icons/chef-hat.svg?react'),
  cherry: () => import('lucide-static/icons/cherry.svg?react'),
  'chess-bishop': () => import('lucide-static/icons/chess-bishop.svg?react'),
  'chess-king': () => import('lucide-static/icons/chess-king.svg?react'),
  'chess-knight': () => import('lucide-static/icons/chess-knight.svg?react'),
  'chess-pawn': () => import('lucide-static/icons/chess-pawn.svg?react'),
  'chess-queen': () => import('lucide-static/icons/chess-queen.svg?react'),
  'chess-rook': () => import('lucide-static/icons/chess-rook.svg?react'),
  'chevron-down-circle': () => import('lucide-static/icons/chevron-down-circle.svg?react'),
  'chevron-down-square': () => import('lucide-static/icons/chevron-down-square.svg?react'),
  'chevron-down': () => import('lucide-static/icons/chevron-down.svg?react'),
  'chevron-first': () => import('lucide-static/icons/chevron-first.svg?react'),
  'chevron-last': () => import('lucide-static/icons/chevron-last.svg?react'),
  'chevron-left-circle': () => import('lucide-static/icons/chevron-left-circle.svg?react'),
  'chevron-left-square': () => import('lucide-static/icons/chevron-left-square.svg?react'),
  'chevron-left': () => import('lucide-static/icons/chevron-left.svg?react'),
  'chevron-right-circle': () => import('lucide-static/icons/chevron-right-circle.svg?react'),
  'chevron-right-square': () => import('lucide-static/icons/chevron-right-square.svg?react'),
  'chevron-right': () => import('lucide-static/icons/chevron-right.svg?react'),
  'chevron-up-circle': () => import('lucide-static/icons/chevron-up-circle.svg?react'),
  'chevron-up-square': () => import('lucide-static/icons/chevron-up-square.svg?react'),
  'chevron-up': () => import('lucide-static/icons/chevron-up.svg?react'),
  'chevrons-down-up': () => import('lucide-static/icons/chevrons-down-up.svg?react'),
  'chevrons-down': () => import('lucide-static/icons/chevrons-down.svg?react'),
  'chevrons-left-right-ellipsis': () =>
    import('lucide-static/icons/chevrons-left-right-ellipsis.svg?react'),
  'chevrons-left-right': () => import('lucide-static/icons/chevrons-left-right.svg?react'),
  'chevrons-left': () => import('lucide-static/icons/chevrons-left.svg?react'),
  'chevrons-right-left': () => import('lucide-static/icons/chevrons-right-left.svg?react'),
  'chevrons-right': () => import('lucide-static/icons/chevrons-right.svg?react'),
  'chevrons-up-down': () => import('lucide-static/icons/chevrons-up-down.svg?react'),
  'chevrons-up': () => import('lucide-static/icons/chevrons-up.svg?react'),
  chrome: () => import('lucide-static/icons/chrome.svg?react'),
  chromium: () => import('lucide-static/icons/chromium.svg?react'),
  church: () => import('lucide-static/icons/church.svg?react'),
  'cigarette-off': () => import('lucide-static/icons/cigarette-off.svg?react'),
  cigarette: () => import('lucide-static/icons/cigarette.svg?react'),
  'circle-alert': () => import('lucide-static/icons/circle-alert.svg?react'),
  'circle-arrow-down': () => import('lucide-static/icons/circle-arrow-down.svg?react'),
  'circle-arrow-left': () => import('lucide-static/icons/circle-arrow-left.svg?react'),
  'circle-arrow-out-down-left': () =>
    import('lucide-static/icons/circle-arrow-out-down-left.svg?react'),
  'circle-arrow-out-down-right': () =>
    import('lucide-static/icons/circle-arrow-out-down-right.svg?react'),
  'circle-arrow-out-up-left': () =>
    import('lucide-static/icons/circle-arrow-out-up-left.svg?react'),
  'circle-arrow-out-up-right': () =>
    import('lucide-static/icons/circle-arrow-out-up-right.svg?react'),
  'circle-arrow-right': () => import('lucide-static/icons/circle-arrow-right.svg?react'),
  'circle-arrow-up': () => import('lucide-static/icons/circle-arrow-up.svg?react'),
  'circle-check-big': () => import('lucide-static/icons/circle-check-big.svg?react'),
  'circle-check': () => import('lucide-static/icons/circle-check.svg?react'),
  'circle-chevron-down': () => import('lucide-static/icons/circle-chevron-down.svg?react'),
  'circle-chevron-left': () => import('lucide-static/icons/circle-chevron-left.svg?react'),
  'circle-chevron-right': () => import('lucide-static/icons/circle-chevron-right.svg?react'),
  'circle-chevron-up': () => import('lucide-static/icons/circle-chevron-up.svg?react'),
  'circle-dashed': () => import('lucide-static/icons/circle-dashed.svg?react'),
  'circle-divide': () => import('lucide-static/icons/circle-divide.svg?react'),
  'circle-dollar-sign': () => import('lucide-static/icons/circle-dollar-sign.svg?react'),
  'circle-dot-dashed': () => import('lucide-static/icons/circle-dot-dashed.svg?react'),
  'circle-dot': () => import('lucide-static/icons/circle-dot.svg?react'),
  'circle-ellipsis': () => import('lucide-static/icons/circle-ellipsis.svg?react'),
  'circle-equal': () => import('lucide-static/icons/circle-equal.svg?react'),
  'circle-fading-arrow-up': () => import('lucide-static/icons/circle-fading-arrow-up.svg?react'),
  'circle-fading-plus': () => import('lucide-static/icons/circle-fading-plus.svg?react'),
  'circle-gauge': () => import('lucide-static/icons/circle-gauge.svg?react'),
  'circle-help': () => import('lucide-static/icons/circle-help.svg?react'),
  'circle-minus': () => import('lucide-static/icons/circle-minus.svg?react'),
  'circle-off': () => import('lucide-static/icons/circle-off.svg?react'),
  'circle-parking-off': () => import('lucide-static/icons/circle-parking-off.svg?react'),
  'circle-parking': () => import('lucide-static/icons/circle-parking.svg?react'),
  'circle-pause': () => import('lucide-static/icons/circle-pause.svg?react'),
  'circle-percent': () => import('lucide-static/icons/circle-percent.svg?react'),
  'circle-pile': () => import('lucide-static/icons/circle-pile.svg?react'),
  'circle-play': () => import('lucide-static/icons/circle-play.svg?react'),
  'circle-plus': () => import('lucide-static/icons/circle-plus.svg?react'),
  'circle-pound-sterling': () => import('lucide-static/icons/circle-pound-sterling.svg?react'),
  'circle-power': () => import('lucide-static/icons/circle-power.svg?react'),
  'circle-question-mark': () => import('lucide-static/icons/circle-question-mark.svg?react'),
  'circle-slash-2': () => import('lucide-static/icons/circle-slash-2.svg?react'),
  'circle-slash': () => import('lucide-static/icons/circle-slash.svg?react'),
  'circle-slashed': () => import('lucide-static/icons/circle-slashed.svg?react'),
  'circle-small': () => import('lucide-static/icons/circle-small.svg?react'),
  'circle-star': () => import('lucide-static/icons/circle-star.svg?react'),
  'circle-stop': () => import('lucide-static/icons/circle-stop.svg?react'),
  'circle-user-round': () => import('lucide-static/icons/circle-user-round.svg?react'),
  'circle-user': () => import('lucide-static/icons/circle-user.svg?react'),
  'circle-x': () => import('lucide-static/icons/circle-x.svg?react'),
  circle: () => import('lucide-static/icons/circle.svg?react'),
  'circuit-board': () => import('lucide-static/icons/circuit-board.svg?react'),
  citrus: () => import('lucide-static/icons/citrus.svg?react'),
  clapperboard: () => import('lucide-static/icons/clapperboard.svg?react'),
  'clipboard-check': () => import('lucide-static/icons/clipboard-check.svg?react'),
  'clipboard-clock': () => import('lucide-static/icons/clipboard-clock.svg?react'),
  'clipboard-copy': () => import('lucide-static/icons/clipboard-copy.svg?react'),
  'clipboard-edit': () => import('lucide-static/icons/clipboard-edit.svg?react'),
  'clipboard-list': () => import('lucide-static/icons/clipboard-list.svg?react'),
  'clipboard-minus': () => import('lucide-static/icons/clipboard-minus.svg?react'),
  'clipboard-paste': () => import('lucide-static/icons/clipboard-paste.svg?react'),
  'clipboard-pen-line': () => import('lucide-static/icons/clipboard-pen-line.svg?react'),
  'clipboard-pen': () => import('lucide-static/icons/clipboard-pen.svg?react'),
  'clipboard-plus': () => import('lucide-static/icons/clipboard-plus.svg?react'),
  'clipboard-signature': () => import('lucide-static/icons/clipboard-signature.svg?react'),
  'clipboard-type': () => import('lucide-static/icons/clipboard-type.svg?react'),
  'clipboard-x': () => import('lucide-static/icons/clipboard-x.svg?react'),
  clipboard: () => import('lucide-static/icons/clipboard.svg?react'),
  'clock-1': () => import('lucide-static/icons/clock-1.svg?react'),
  'clock-10': () => import('lucide-static/icons/clock-10.svg?react'),
  'clock-11': () => import('lucide-static/icons/clock-11.svg?react'),
  'clock-12': () => import('lucide-static/icons/clock-12.svg?react'),
  'clock-2': () => import('lucide-static/icons/clock-2.svg?react'),
  'clock-3': () => import('lucide-static/icons/clock-3.svg?react'),
  'clock-4': () => import('lucide-static/icons/clock-4.svg?react'),
  'clock-5': () => import('lucide-static/icons/clock-5.svg?react'),
  'clock-6': () => import('lucide-static/icons/clock-6.svg?react'),
  'clock-7': () => import('lucide-static/icons/clock-7.svg?react'),
  'clock-8': () => import('lucide-static/icons/clock-8.svg?react'),
  'clock-9': () => import('lucide-static/icons/clock-9.svg?react'),
  'clock-alert': () => import('lucide-static/icons/clock-alert.svg?react'),
  'clock-arrow-down': () => import('lucide-static/icons/clock-arrow-down.svg?react'),
  'clock-arrow-up': () => import('lucide-static/icons/clock-arrow-up.svg?react'),
  'clock-check': () => import('lucide-static/icons/clock-check.svg?react'),
  'clock-fading': () => import('lucide-static/icons/clock-fading.svg?react'),
  'clock-plus': () => import('lucide-static/icons/clock-plus.svg?react'),
  clock: () => import('lucide-static/icons/clock.svg?react'),
  'closed-caption': () => import('lucide-static/icons/closed-caption.svg?react'),
  'cloud-alert': () => import('lucide-static/icons/cloud-alert.svg?react'),
  'cloud-backup': () => import('lucide-static/icons/cloud-backup.svg?react'),
  'cloud-check': () => import('lucide-static/icons/cloud-check.svg?react'),
  'cloud-cog': () => import('lucide-static/icons/cloud-cog.svg?react'),
  'cloud-download': () => import('lucide-static/icons/cloud-download.svg?react'),
  'cloud-drizzle': () => import('lucide-static/icons/cloud-drizzle.svg?react'),
  'cloud-fog': () => import('lucide-static/icons/cloud-fog.svg?react'),
  'cloud-hail': () => import('lucide-static/icons/cloud-hail.svg?react'),
  'cloud-lightning': () => import('lucide-static/icons/cloud-lightning.svg?react'),
  'cloud-moon-rain': () => import('lucide-static/icons/cloud-moon-rain.svg?react'),
  'cloud-moon': () => import('lucide-static/icons/cloud-moon.svg?react'),
  'cloud-off': () => import('lucide-static/icons/cloud-off.svg?react'),
  'cloud-rain-wind': () => import('lucide-static/icons/cloud-rain-wind.svg?react'),
  'cloud-rain': () => import('lucide-static/icons/cloud-rain.svg?react'),
  'cloud-snow': () => import('lucide-static/icons/cloud-snow.svg?react'),
  'cloud-sun-rain': () => import('lucide-static/icons/cloud-sun-rain.svg?react'),
  'cloud-sun': () => import('lucide-static/icons/cloud-sun.svg?react'),
  'cloud-sync': () => import('lucide-static/icons/cloud-sync.svg?react'),
  'cloud-upload': () => import('lucide-static/icons/cloud-upload.svg?react'),
  cloud: () => import('lucide-static/icons/cloud.svg?react'),
  cloudy: () => import('lucide-static/icons/cloudy.svg?react'),
  clover: () => import('lucide-static/icons/clover.svg?react'),
  club: () => import('lucide-static/icons/club.svg?react'),
  'code-2': () => import('lucide-static/icons/code-2.svg?react'),
  'code-square': () => import('lucide-static/icons/code-square.svg?react'),
  'code-xml': () => import('lucide-static/icons/code-xml.svg?react'),
  code: () => import('lucide-static/icons/code.svg?react'),
  codepen: () => import('lucide-static/icons/codepen.svg?react'),
  codesandbox: () => import('lucide-static/icons/codesandbox.svg?react'),
  coffee: () => import('lucide-static/icons/coffee.svg?react'),
  cog: () => import('lucide-static/icons/cog.svg?react'),
  coins: () => import('lucide-static/icons/coins.svg?react'),
  'columns-2': () => import('lucide-static/icons/columns-2.svg?react'),
  'columns-3-cog': () => import('lucide-static/icons/columns-3-cog.svg?react'),
  'columns-3': () => import('lucide-static/icons/columns-3.svg?react'),
  'columns-4': () => import('lucide-static/icons/columns-4.svg?react'),
  'columns-settings': () => import('lucide-static/icons/columns-settings.svg?react'),
  columns: () => import('lucide-static/icons/columns.svg?react'),
  combine: () => import('lucide-static/icons/combine.svg?react'),
  command: () => import('lucide-static/icons/command.svg?react'),
  compass: () => import('lucide-static/icons/compass.svg?react'),
  component: () => import('lucide-static/icons/component.svg?react'),
  computer: () => import('lucide-static/icons/computer.svg?react'),
  'concierge-bell': () => import('lucide-static/icons/concierge-bell.svg?react'),
  cone: () => import('lucide-static/icons/cone.svg?react'),
  construction: () => import('lucide-static/icons/construction.svg?react'),
  'contact-2': () => import('lucide-static/icons/contact-2.svg?react'),
  'contact-round': () => import('lucide-static/icons/contact-round.svg?react'),
  contact: () => import('lucide-static/icons/contact.svg?react'),
  container: () => import('lucide-static/icons/container.svg?react'),
  contrast: () => import('lucide-static/icons/contrast.svg?react'),
  cookie: () => import('lucide-static/icons/cookie.svg?react'),
  'cooking-pot': () => import('lucide-static/icons/cooking-pot.svg?react'),
  'copy-check': () => import('lucide-static/icons/copy-check.svg?react'),
  'copy-minus': () => import('lucide-static/icons/copy-minus.svg?react'),
  'copy-plus': () => import('lucide-static/icons/copy-plus.svg?react'),
  'copy-slash': () => import('lucide-static/icons/copy-slash.svg?react'),
  'copy-x': () => import('lucide-static/icons/copy-x.svg?react'),
  copy: () => import('lucide-static/icons/copy.svg?react'),
  copyleft: () => import('lucide-static/icons/copyleft.svg?react'),
  copyright: () => import('lucide-static/icons/copyright.svg?react'),
  'corner-down-left': () => import('lucide-static/icons/corner-down-left.svg?react'),
  'corner-down-right': () => import('lucide-static/icons/corner-down-right.svg?react'),
  'corner-left-down': () => import('lucide-static/icons/corner-left-down.svg?react'),
  'corner-left-up': () => import('lucide-static/icons/corner-left-up.svg?react'),
  'corner-right-down': () => import('lucide-static/icons/corner-right-down.svg?react'),
  'corner-right-up': () => import('lucide-static/icons/corner-right-up.svg?react'),
  'corner-up-left': () => import('lucide-static/icons/corner-up-left.svg?react'),
  'corner-up-right': () => import('lucide-static/icons/corner-up-right.svg?react'),
  cpu: () => import('lucide-static/icons/cpu.svg?react'),
  'creative-commons': () => import('lucide-static/icons/creative-commons.svg?react'),
  'credit-card': () => import('lucide-static/icons/credit-card.svg?react'),
  croissant: () => import('lucide-static/icons/croissant.svg?react'),
  crop: () => import('lucide-static/icons/crop.svg?react'),
  cross: () => import('lucide-static/icons/cross.svg?react'),
  crosshair: () => import('lucide-static/icons/crosshair.svg?react'),
  crown: () => import('lucide-static/icons/crown.svg?react'),
  cuboid: () => import('lucide-static/icons/cuboid.svg?react'),
  'cup-soda': () => import('lucide-static/icons/cup-soda.svg?react'),
  'curly-braces': () => import('lucide-static/icons/curly-braces.svg?react'),
  currency: () => import('lucide-static/icons/currency.svg?react'),
  cylinder: () => import('lucide-static/icons/cylinder.svg?react'),
  dam: () => import('lucide-static/icons/dam.svg?react'),
  'database-backup': () => import('lucide-static/icons/database-backup.svg?react'),
  'database-zap': () => import('lucide-static/icons/database-zap.svg?react'),
  database: () => import('lucide-static/icons/database.svg?react'),
  'decimals-arrow-left': () => import('lucide-static/icons/decimals-arrow-left.svg?react'),
  'decimals-arrow-right': () => import('lucide-static/icons/decimals-arrow-right.svg?react'),
  delete: () => import('lucide-static/icons/delete.svg?react'),
  dessert: () => import('lucide-static/icons/dessert.svg?react'),
  diameter: () => import('lucide-static/icons/diameter.svg?react'),
  'diamond-minus': () => import('lucide-static/icons/diamond-minus.svg?react'),
  'diamond-percent': () => import('lucide-static/icons/diamond-percent.svg?react'),
  'diamond-plus': () => import('lucide-static/icons/diamond-plus.svg?react'),
  diamond: () => import('lucide-static/icons/diamond.svg?react'),
  'dice-1': () => import('lucide-static/icons/dice-1.svg?react'),
  'dice-2': () => import('lucide-static/icons/dice-2.svg?react'),
  'dice-3': () => import('lucide-static/icons/dice-3.svg?react'),
  'dice-4': () => import('lucide-static/icons/dice-4.svg?react'),
  'dice-5': () => import('lucide-static/icons/dice-5.svg?react'),
  'dice-6': () => import('lucide-static/icons/dice-6.svg?react'),
  dices: () => import('lucide-static/icons/dices.svg?react'),
  diff: () => import('lucide-static/icons/diff.svg?react'),
  'disc-2': () => import('lucide-static/icons/disc-2.svg?react'),
  'disc-3': () => import('lucide-static/icons/disc-3.svg?react'),
  'disc-album': () => import('lucide-static/icons/disc-album.svg?react'),
  disc: () => import('lucide-static/icons/disc.svg?react'),
  'divide-circle': () => import('lucide-static/icons/divide-circle.svg?react'),
  'divide-square': () => import('lucide-static/icons/divide-square.svg?react'),
  divide: () => import('lucide-static/icons/divide.svg?react'),
  'dna-off': () => import('lucide-static/icons/dna-off.svg?react'),
  dna: () => import('lucide-static/icons/dna.svg?react'),
  dock: () => import('lucide-static/icons/dock.svg?react'),
  dog: () => import('lucide-static/icons/dog.svg?react'),
  'dollar-sign': () => import('lucide-static/icons/dollar-sign.svg?react'),
  donut: () => import('lucide-static/icons/donut.svg?react'),
  'door-closed-locked': () => import('lucide-static/icons/door-closed-locked.svg?react'),
  'door-closed': () => import('lucide-static/icons/door-closed.svg?react'),
  'door-open': () => import('lucide-static/icons/door-open.svg?react'),
  'dot-square': () => import('lucide-static/icons/dot-square.svg?react'),
  dot: () => import('lucide-static/icons/dot.svg?react'),
  'download-cloud': () => import('lucide-static/icons/download-cloud.svg?react'),
  download: () => import('lucide-static/icons/download.svg?react'),
  'drafting-compass': () => import('lucide-static/icons/drafting-compass.svg?react'),
  drama: () => import('lucide-static/icons/drama.svg?react'),
  dribbble: () => import('lucide-static/icons/dribbble.svg?react'),
  drill: () => import('lucide-static/icons/drill.svg?react'),
  drone: () => import('lucide-static/icons/drone.svg?react'),
  'droplet-off': () => import('lucide-static/icons/droplet-off.svg?react'),
  droplet: () => import('lucide-static/icons/droplet.svg?react'),
  droplets: () => import('lucide-static/icons/droplets.svg?react'),
  drum: () => import('lucide-static/icons/drum.svg?react'),
  drumstick: () => import('lucide-static/icons/drumstick.svg?react'),
  dumbbell: () => import('lucide-static/icons/dumbbell.svg?react'),
  'ear-off': () => import('lucide-static/icons/ear-off.svg?react'),
  ear: () => import('lucide-static/icons/ear.svg?react'),
  'earth-lock': () => import('lucide-static/icons/earth-lock.svg?react'),
  earth: () => import('lucide-static/icons/earth.svg?react'),
  eclipse: () => import('lucide-static/icons/eclipse.svg?react'),
  'edit-2': () => import('lucide-static/icons/edit-2.svg?react'),
  'edit-3': () => import('lucide-static/icons/edit-3.svg?react'),
  edit: () => import('lucide-static/icons/edit.svg?react'),
  'egg-fried': () => import('lucide-static/icons/egg-fried.svg?react'),
  'egg-off': () => import('lucide-static/icons/egg-off.svg?react'),
  egg: () => import('lucide-static/icons/egg.svg?react'),
  'ellipsis-vertical': () => import('lucide-static/icons/ellipsis-vertical.svg?react'),
  ellipsis: () => import('lucide-static/icons/ellipsis.svg?react'),
  'equal-approximately': () => import('lucide-static/icons/equal-approximately.svg?react'),
  'equal-not': () => import('lucide-static/icons/equal-not.svg?react'),
  'equal-square': () => import('lucide-static/icons/equal-square.svg?react'),
  equal: () => import('lucide-static/icons/equal.svg?react'),
  eraser: () => import('lucide-static/icons/eraser.svg?react'),
  'ethernet-port': () => import('lucide-static/icons/ethernet-port.svg?react'),
  euro: () => import('lucide-static/icons/euro.svg?react'),
  'ev-charger': () => import('lucide-static/icons/ev-charger.svg?react'),
  expand: () => import('lucide-static/icons/expand.svg?react'),
  'external-link': () => import('lucide-static/icons/external-link.svg?react'),
  'eye-closed': () => import('lucide-static/icons/eye-closed.svg?react'),
  'eye-off': () => import('lucide-static/icons/eye-off.svg?react'),
  eye: () => import('lucide-static/icons/eye.svg?react'),
  facebook: () => import('lucide-static/icons/facebook.svg?react'),
  factory: () => import('lucide-static/icons/factory.svg?react'),
  fan: () => import('lucide-static/icons/fan.svg?react'),
  'fast-forward': () => import('lucide-static/icons/fast-forward.svg?react'),
  feather: () => import('lucide-static/icons/feather.svg?react'),
  fence: () => import('lucide-static/icons/fence.svg?react'),
  'ferris-wheel': () => import('lucide-static/icons/ferris-wheel.svg?react'),
  figma: () => import('lucide-static/icons/figma.svg?react'),
  'file-archive': () => import('lucide-static/icons/file-archive.svg?react'),
  'file-audio-2': () => import('lucide-static/icons/file-audio-2.svg?react'),
  'file-audio': () => import('lucide-static/icons/file-audio.svg?react'),
  'file-axis-3-d': () => import('lucide-static/icons/file-axis-3-d.svg?react'),
  'file-axis-3d': () => import('lucide-static/icons/file-axis-3d.svg?react'),
  'file-badge-2': () => import('lucide-static/icons/file-badge-2.svg?react'),
  'file-badge': () => import('lucide-static/icons/file-badge.svg?react'),
  'file-bar-chart-2': () => import('lucide-static/icons/file-bar-chart-2.svg?react'),
  'file-bar-chart': () => import('lucide-static/icons/file-bar-chart.svg?react'),
  'file-box': () => import('lucide-static/icons/file-box.svg?react'),
  'file-braces-corner': () => import('lucide-static/icons/file-braces-corner.svg?react'),
  'file-braces': () => import('lucide-static/icons/file-braces.svg?react'),
  'file-chart-column-increasing': () =>
    import('lucide-static/icons/file-chart-column-increasing.svg?react'),
  'file-chart-column': () => import('lucide-static/icons/file-chart-column.svg?react'),
  'file-chart-line': () => import('lucide-static/icons/file-chart-line.svg?react'),
  'file-chart-pie': () => import('lucide-static/icons/file-chart-pie.svg?react'),
  'file-check-2': () => import('lucide-static/icons/file-check-2.svg?react'),
  'file-check-corner': () => import('lucide-static/icons/file-check-corner.svg?react'),
  'file-check': () => import('lucide-static/icons/file-check.svg?react'),
  'file-clock': () => import('lucide-static/icons/file-clock.svg?react'),
  'file-code-2': () => import('lucide-static/icons/file-code-2.svg?react'),
  'file-code-corner': () => import('lucide-static/icons/file-code-corner.svg?react'),
  'file-code': () => import('lucide-static/icons/file-code.svg?react'),
  'file-cog-2': () => import('lucide-static/icons/file-cog-2.svg?react'),
  'file-cog': () => import('lucide-static/icons/file-cog.svg?react'),
  'file-diff': () => import('lucide-static/icons/file-diff.svg?react'),
  'file-digit': () => import('lucide-static/icons/file-digit.svg?react'),
  'file-down': () => import('lucide-static/icons/file-down.svg?react'),
  'file-edit': () => import('lucide-static/icons/file-edit.svg?react'),
  'file-exclamation-point': () => import('lucide-static/icons/file-exclamation-point.svg?react'),
  'file-headphone': () => import('lucide-static/icons/file-headphone.svg?react'),
  'file-heart': () => import('lucide-static/icons/file-heart.svg?react'),
  'file-image': () => import('lucide-static/icons/file-image.svg?react'),
  'file-input': () => import('lucide-static/icons/file-input.svg?react'),
  'file-json-2': () => import('lucide-static/icons/file-json-2.svg?react'),
  'file-json': () => import('lucide-static/icons/file-json.svg?react'),
  'file-key-2': () => import('lucide-static/icons/file-key-2.svg?react'),
  'file-key': () => import('lucide-static/icons/file-key.svg?react'),
  'file-line-chart': () => import('lucide-static/icons/file-line-chart.svg?react'),
  'file-lock-2': () => import('lucide-static/icons/file-lock-2.svg?react'),
  'file-lock': () => import('lucide-static/icons/file-lock.svg?react'),
  'file-minus-2': () => import('lucide-static/icons/file-minus-2.svg?react'),
  'file-minus-corner': () => import('lucide-static/icons/file-minus-corner.svg?react'),
  'file-minus': () => import('lucide-static/icons/file-minus.svg?react'),
  'file-music': () => import('lucide-static/icons/file-music.svg?react'),
  'file-output': () => import('lucide-static/icons/file-output.svg?react'),
  'file-pen-line': () => import('lucide-static/icons/file-pen-line.svg?react'),
  'file-pen': () => import('lucide-static/icons/file-pen.svg?react'),
  'file-pie-chart': () => import('lucide-static/icons/file-pie-chart.svg?react'),
  'file-play': () => import('lucide-static/icons/file-play.svg?react'),
  'file-plus-2': () => import('lucide-static/icons/file-plus-2.svg?react'),
  'file-plus-corner': () => import('lucide-static/icons/file-plus-corner.svg?react'),
  'file-plus': () => import('lucide-static/icons/file-plus.svg?react'),
  'file-question-mark': () => import('lucide-static/icons/file-question-mark.svg?react'),
  'file-question': () => import('lucide-static/icons/file-question.svg?react'),
  'file-scan': () => import('lucide-static/icons/file-scan.svg?react'),
  'file-search-2': () => import('lucide-static/icons/file-search-2.svg?react'),
  'file-search-corner': () => import('lucide-static/icons/file-search-corner.svg?react'),
  'file-search': () => import('lucide-static/icons/file-search.svg?react'),
  'file-signal': () => import('lucide-static/icons/file-signal.svg?react'),
  'file-signature': () => import('lucide-static/icons/file-signature.svg?react'),
  'file-sliders': () => import('lucide-static/icons/file-sliders.svg?react'),
  'file-spreadsheet': () => import('lucide-static/icons/file-spreadsheet.svg?react'),
  'file-stack': () => import('lucide-static/icons/file-stack.svg?react'),
  'file-symlink': () => import('lucide-static/icons/file-symlink.svg?react'),
  'file-terminal': () => import('lucide-static/icons/file-terminal.svg?react'),
  'file-text': () => import('lucide-static/icons/file-text.svg?react'),
  'file-type-2': () => import('lucide-static/icons/file-type-2.svg?react'),
  'file-type-corner': () => import('lucide-static/icons/file-type-corner.svg?react'),
  'file-type': () => import('lucide-static/icons/file-type.svg?react'),
  'file-up': () => import('lucide-static/icons/file-up.svg?react'),
  'file-user': () => import('lucide-static/icons/file-user.svg?react'),
  'file-video-2': () => import('lucide-static/icons/file-video-2.svg?react'),
  'file-video-camera': () => import('lucide-static/icons/file-video-camera.svg?react'),
  'file-video': () => import('lucide-static/icons/file-video.svg?react'),
  'file-volume-2': () => import('lucide-static/icons/file-volume-2.svg?react'),
  'file-volume': () => import('lucide-static/icons/file-volume.svg?react'),
  'file-warning': () => import('lucide-static/icons/file-warning.svg?react'),
  'file-x-2': () => import('lucide-static/icons/file-x-2.svg?react'),
  'file-x-corner': () => import('lucide-static/icons/file-x-corner.svg?react'),
  'file-x': () => import('lucide-static/icons/file-x.svg?react'),
  file: () => import('lucide-static/icons/file.svg?react'),
  files: () => import('lucide-static/icons/files.svg?react'),
  film: () => import('lucide-static/icons/film.svg?react'),
  'filter-x': () => import('lucide-static/icons/filter-x.svg?react'),
  filter: () => import('lucide-static/icons/filter.svg?react'),
  'fingerprint-pattern': () => import('lucide-static/icons/fingerprint-pattern.svg?react'),
  fingerprint: () => import('lucide-static/icons/fingerprint.svg?react'),
  'fire-extinguisher': () => import('lucide-static/icons/fire-extinguisher.svg?react'),
  'fish-off': () => import('lucide-static/icons/fish-off.svg?react'),
  'fish-symbol': () => import('lucide-static/icons/fish-symbol.svg?react'),
  fish: () => import('lucide-static/icons/fish.svg?react'),
  'fishing-hook': () => import('lucide-static/icons/fishing-hook.svg?react'),
  'flag-off': () => import('lucide-static/icons/flag-off.svg?react'),
  'flag-triangle-left': () => import('lucide-static/icons/flag-triangle-left.svg?react'),
  'flag-triangle-right': () => import('lucide-static/icons/flag-triangle-right.svg?react'),
  flag: () => import('lucide-static/icons/flag.svg?react'),
  'flame-kindling': () => import('lucide-static/icons/flame-kindling.svg?react'),
  flame: () => import('lucide-static/icons/flame.svg?react'),
  'flashlight-off': () => import('lucide-static/icons/flashlight-off.svg?react'),
  flashlight: () => import('lucide-static/icons/flashlight.svg?react'),
  'flask-conical-off': () => import('lucide-static/icons/flask-conical-off.svg?react'),
  'flask-conical': () => import('lucide-static/icons/flask-conical.svg?react'),
  'flask-round': () => import('lucide-static/icons/flask-round.svg?react'),
  'flip-horizontal-2': () => import('lucide-static/icons/flip-horizontal-2.svg?react'),
  'flip-horizontal': () => import('lucide-static/icons/flip-horizontal.svg?react'),
  'flip-vertical-2': () => import('lucide-static/icons/flip-vertical-2.svg?react'),
  'flip-vertical': () => import('lucide-static/icons/flip-vertical.svg?react'),
  'flower-2': () => import('lucide-static/icons/flower-2.svg?react'),
  flower: () => import('lucide-static/icons/flower.svg?react'),
  focus: () => import('lucide-static/icons/focus.svg?react'),
  'fold-horizontal': () => import('lucide-static/icons/fold-horizontal.svg?react'),
  'fold-vertical': () => import('lucide-static/icons/fold-vertical.svg?react'),
  'folder-archive': () => import('lucide-static/icons/folder-archive.svg?react'),
  'folder-check': () => import('lucide-static/icons/folder-check.svg?react'),
  'folder-clock': () => import('lucide-static/icons/folder-clock.svg?react'),
  'folder-closed': () => import('lucide-static/icons/folder-closed.svg?react'),
  'folder-code': () => import('lucide-static/icons/folder-code.svg?react'),
  'folder-cog-2': () => import('lucide-static/icons/folder-cog-2.svg?react'),
  'folder-cog': () => import('lucide-static/icons/folder-cog.svg?react'),
  'folder-dot': () => import('lucide-static/icons/folder-dot.svg?react'),
  'folder-down': () => import('lucide-static/icons/folder-down.svg?react'),
  'folder-edit': () => import('lucide-static/icons/folder-edit.svg?react'),
  'folder-git-2': () => import('lucide-static/icons/folder-git-2.svg?react'),
  'folder-git': () => import('lucide-static/icons/folder-git.svg?react'),
  'folder-heart': () => import('lucide-static/icons/folder-heart.svg?react'),
  'folder-input': () => import('lucide-static/icons/folder-input.svg?react'),
  'folder-kanban': () => import('lucide-static/icons/folder-kanban.svg?react'),
  'folder-key': () => import('lucide-static/icons/folder-key.svg?react'),
  'folder-lock': () => import('lucide-static/icons/folder-lock.svg?react'),
  'folder-minus': () => import('lucide-static/icons/folder-minus.svg?react'),
  'folder-open-dot': () => import('lucide-static/icons/folder-open-dot.svg?react'),
  'folder-open': () => import('lucide-static/icons/folder-open.svg?react'),
  'folder-output': () => import('lucide-static/icons/folder-output.svg?react'),
  'folder-pen': () => import('lucide-static/icons/folder-pen.svg?react'),
  'folder-plus': () => import('lucide-static/icons/folder-plus.svg?react'),
  'folder-root': () => import('lucide-static/icons/folder-root.svg?react'),
  'folder-search-2': () => import('lucide-static/icons/folder-search-2.svg?react'),
  'folder-search': () => import('lucide-static/icons/folder-search.svg?react'),
  'folder-symlink': () => import('lucide-static/icons/folder-symlink.svg?react'),
  'folder-sync': () => import('lucide-static/icons/folder-sync.svg?react'),
  'folder-tree': () => import('lucide-static/icons/folder-tree.svg?react'),
  'folder-up': () => import('lucide-static/icons/folder-up.svg?react'),
  'folder-x': () => import('lucide-static/icons/folder-x.svg?react'),
  folder: () => import('lucide-static/icons/folder.svg?react'),
  folders: () => import('lucide-static/icons/folders.svg?react'),
  footprints: () => import('lucide-static/icons/footprints.svg?react'),
  'fork-knife-crossed': () => import('lucide-static/icons/fork-knife-crossed.svg?react'),
  'fork-knife': () => import('lucide-static/icons/fork-knife.svg?react'),
  forklift: () => import('lucide-static/icons/forklift.svg?react'),
  'form-input': () => import('lucide-static/icons/form-input.svg?react'),
  form: () => import('lucide-static/icons/form.svg?react'),
  forward: () => import('lucide-static/icons/forward.svg?react'),
  frame: () => import('lucide-static/icons/frame.svg?react'),
  framer: () => import('lucide-static/icons/framer.svg?react'),
  frown: () => import('lucide-static/icons/frown.svg?react'),
  fuel: () => import('lucide-static/icons/fuel.svg?react'),
  fullscreen: () => import('lucide-static/icons/fullscreen.svg?react'),
  'function-square': () => import('lucide-static/icons/function-square.svg?react'),
  'funnel-plus': () => import('lucide-static/icons/funnel-plus.svg?react'),
  'funnel-x': () => import('lucide-static/icons/funnel-x.svg?react'),
  funnel: () => import('lucide-static/icons/funnel.svg?react'),
  'gallery-horizontal-end': () => import('lucide-static/icons/gallery-horizontal-end.svg?react'),
  'gallery-horizontal': () => import('lucide-static/icons/gallery-horizontal.svg?react'),
  'gallery-thumbnails': () => import('lucide-static/icons/gallery-thumbnails.svg?react'),
  'gallery-vertical-end': () => import('lucide-static/icons/gallery-vertical-end.svg?react'),
  'gallery-vertical': () => import('lucide-static/icons/gallery-vertical.svg?react'),
  'gamepad-2': () => import('lucide-static/icons/gamepad-2.svg?react'),
  'gamepad-directional': () => import('lucide-static/icons/gamepad-directional.svg?react'),
  gamepad: () => import('lucide-static/icons/gamepad.svg?react'),
  'gantt-chart-square': () => import('lucide-static/icons/gantt-chart-square.svg?react'),
  'gantt-chart': () => import('lucide-static/icons/gantt-chart.svg?react'),
  'gauge-circle': () => import('lucide-static/icons/gauge-circle.svg?react'),
  gauge: () => import('lucide-static/icons/gauge.svg?react'),
  gavel: () => import('lucide-static/icons/gavel.svg?react'),
  gem: () => import('lucide-static/icons/gem.svg?react'),
  'georgian-lari': () => import('lucide-static/icons/georgian-lari.svg?react'),
  ghost: () => import('lucide-static/icons/ghost.svg?react'),
  gift: () => import('lucide-static/icons/gift.svg?react'),
  'git-branch-minus': () => import('lucide-static/icons/git-branch-minus.svg?react'),
  'git-branch-plus': () => import('lucide-static/icons/git-branch-plus.svg?react'),
  'git-branch': () => import('lucide-static/icons/git-branch.svg?react'),
  'git-commit-horizontal': () => import('lucide-static/icons/git-commit-horizontal.svg?react'),
  'git-commit-vertical': () => import('lucide-static/icons/git-commit-vertical.svg?react'),
  'git-commit': () => import('lucide-static/icons/git-commit.svg?react'),
  'git-compare-arrows': () => import('lucide-static/icons/git-compare-arrows.svg?react'),
  'git-compare': () => import('lucide-static/icons/git-compare.svg?react'),
  'git-fork': () => import('lucide-static/icons/git-fork.svg?react'),
  'git-graph': () => import('lucide-static/icons/git-graph.svg?react'),
  'git-merge': () => import('lucide-static/icons/git-merge.svg?react'),
  'git-pull-request-arrow': () => import('lucide-static/icons/git-pull-request-arrow.svg?react'),
  'git-pull-request-closed': () => import('lucide-static/icons/git-pull-request-closed.svg?react'),
  'git-pull-request-create-arrow': () =>
    import('lucide-static/icons/git-pull-request-create-arrow.svg?react'),
  'git-pull-request-create': () => import('lucide-static/icons/git-pull-request-create.svg?react'),
  'git-pull-request-draft': () => import('lucide-static/icons/git-pull-request-draft.svg?react'),
  'git-pull-request': () => import('lucide-static/icons/git-pull-request.svg?react'),
  github: () => import('lucide-static/icons/github.svg?react'),
  gitlab: () => import('lucide-static/icons/gitlab.svg?react'),
  'glass-water': () => import('lucide-static/icons/glass-water.svg?react'),
  glasses: () => import('lucide-static/icons/glasses.svg?react'),
  'globe-2': () => import('lucide-static/icons/globe-2.svg?react'),
  'globe-lock': () => import('lucide-static/icons/globe-lock.svg?react'),
  'globe-x': () => import('lucide-static/icons/globe-x.svg?react'),
  globe: () => import('lucide-static/icons/globe.svg?react'),
  goal: () => import('lucide-static/icons/goal.svg?react'),
  gpu: () => import('lucide-static/icons/gpu.svg?react'),
  grab: () => import('lucide-static/icons/grab.svg?react'),
  'graduation-cap': () => import('lucide-static/icons/graduation-cap.svg?react'),
  grape: () => import('lucide-static/icons/grape.svg?react'),
  'grid-2-x-2-check': () => import('lucide-static/icons/grid-2-x-2-check.svg?react'),
  'grid-2-x-2-plus': () => import('lucide-static/icons/grid-2-x-2-plus.svg?react'),
  'grid-2-x-2-x': () => import('lucide-static/icons/grid-2-x-2-x.svg?react'),
  'grid-2-x-2': () => import('lucide-static/icons/grid-2-x-2.svg?react'),
  'grid-2x2-check': () => import('lucide-static/icons/grid-2x2-check.svg?react'),
  'grid-2x2-plus': () => import('lucide-static/icons/grid-2x2-plus.svg?react'),
  'grid-2x2-x': () => import('lucide-static/icons/grid-2x2-x.svg?react'),
  'grid-2x2': () => import('lucide-static/icons/grid-2x2.svg?react'),
  'grid-3-x-3': () => import('lucide-static/icons/grid-3-x-3.svg?react'),
  'grid-3x2': () => import('lucide-static/icons/grid-3x2.svg?react'),
  'grid-3x3': () => import('lucide-static/icons/grid-3x3.svg?react'),
  grid: () => import('lucide-static/icons/grid.svg?react'),
  'grip-horizontal': () => import('lucide-static/icons/grip-horizontal.svg?react'),
  'grip-vertical': () => import('lucide-static/icons/grip-vertical.svg?react'),
  grip: () => import('lucide-static/icons/grip.svg?react'),
  group: () => import('lucide-static/icons/group.svg?react'),
  guitar: () => import('lucide-static/icons/guitar.svg?react'),
  ham: () => import('lucide-static/icons/ham.svg?react'),
  hamburger: () => import('lucide-static/icons/hamburger.svg?react'),
  hammer: () => import('lucide-static/icons/hammer.svg?react'),
  'hand-coins': () => import('lucide-static/icons/hand-coins.svg?react'),
  'hand-fist': () => import('lucide-static/icons/hand-fist.svg?react'),
  'hand-grab': () => import('lucide-static/icons/hand-grab.svg?react'),
  'hand-heart': () => import('lucide-static/icons/hand-heart.svg?react'),
  'hand-helping': () => import('lucide-static/icons/hand-helping.svg?react'),
  'hand-metal': () => import('lucide-static/icons/hand-metal.svg?react'),
  'hand-platter': () => import('lucide-static/icons/hand-platter.svg?react'),
  hand: () => import('lucide-static/icons/hand.svg?react'),
  handbag: () => import('lucide-static/icons/handbag.svg?react'),
  handshake: () => import('lucide-static/icons/handshake.svg?react'),
  'hard-drive-download': () => import('lucide-static/icons/hard-drive-download.svg?react'),
  'hard-drive-upload': () => import('lucide-static/icons/hard-drive-upload.svg?react'),
  'hard-drive': () => import('lucide-static/icons/hard-drive.svg?react'),
  'hard-hat': () => import('lucide-static/icons/hard-hat.svg?react'),
  hash: () => import('lucide-static/icons/hash.svg?react'),
  'hat-glasses': () => import('lucide-static/icons/hat-glasses.svg?react'),
  haze: () => import('lucide-static/icons/haze.svg?react'),
  hd: () => import('lucide-static/icons/hd.svg?react'),
  'hdmi-port': () => import('lucide-static/icons/hdmi-port.svg?react'),
  'heading-1': () => import('lucide-static/icons/heading-1.svg?react'),
  'heading-2': () => import('lucide-static/icons/heading-2.svg?react'),
  'heading-3': () => import('lucide-static/icons/heading-3.svg?react'),
  'heading-4': () => import('lucide-static/icons/heading-4.svg?react'),
  'heading-5': () => import('lucide-static/icons/heading-5.svg?react'),
  'heading-6': () => import('lucide-static/icons/heading-6.svg?react'),
  heading: () => import('lucide-static/icons/heading.svg?react'),
  'headphone-off': () => import('lucide-static/icons/headphone-off.svg?react'),
  headphones: () => import('lucide-static/icons/headphones.svg?react'),
  headset: () => import('lucide-static/icons/headset.svg?react'),
  'heart-crack': () => import('lucide-static/icons/heart-crack.svg?react'),
  'heart-handshake': () => import('lucide-static/icons/heart-handshake.svg?react'),
  'heart-minus': () => import('lucide-static/icons/heart-minus.svg?react'),
  'heart-off': () => import('lucide-static/icons/heart-off.svg?react'),
  'heart-plus': () => import('lucide-static/icons/heart-plus.svg?react'),
  'heart-pulse': () => import('lucide-static/icons/heart-pulse.svg?react'),
  heart: () => import('lucide-static/icons/heart.svg?react'),
  heater: () => import('lucide-static/icons/heater.svg?react'),
  helicopter: () => import('lucide-static/icons/helicopter.svg?react'),
  'help-circle': () => import('lucide-static/icons/help-circle.svg?react'),
  'helping-hand': () => import('lucide-static/icons/helping-hand.svg?react'),
  hexagon: () => import('lucide-static/icons/hexagon.svg?react'),
  highlighter: () => import('lucide-static/icons/highlighter.svg?react'),
  history: () => import('lucide-static/icons/history.svg?react'),
  home: () => import('lucide-static/icons/home.svg?react'),
  'hop-off': () => import('lucide-static/icons/hop-off.svg?react'),
  hop: () => import('lucide-static/icons/hop.svg?react'),
  hospital: () => import('lucide-static/icons/hospital.svg?react'),
  hotel: () => import('lucide-static/icons/hotel.svg?react'),
  hourglass: () => import('lucide-static/icons/hourglass.svg?react'),
  'house-heart': () => import('lucide-static/icons/house-heart.svg?react'),
  'house-plug': () => import('lucide-static/icons/house-plug.svg?react'),
  'house-plus': () => import('lucide-static/icons/house-plus.svg?react'),
  'house-wifi': () => import('lucide-static/icons/house-wifi.svg?react'),
  house: () => import('lucide-static/icons/house.svg?react'),
  'ice-cream-2': () => import('lucide-static/icons/ice-cream-2.svg?react'),
  'ice-cream-bowl': () => import('lucide-static/icons/ice-cream-bowl.svg?react'),
  'ice-cream-cone': () => import('lucide-static/icons/ice-cream-cone.svg?react'),
  'ice-cream': () => import('lucide-static/icons/ice-cream.svg?react'),
  'id-card-lanyard': () => import('lucide-static/icons/id-card-lanyard.svg?react'),
  'id-card': () => import('lucide-static/icons/id-card.svg?react'),
  'image-down': () => import('lucide-static/icons/image-down.svg?react'),
  'image-minus': () => import('lucide-static/icons/image-minus.svg?react'),
  'image-off': () => import('lucide-static/icons/image-off.svg?react'),
  'image-play': () => import('lucide-static/icons/image-play.svg?react'),
  'image-plus': () => import('lucide-static/icons/image-plus.svg?react'),
  'image-up': () => import('lucide-static/icons/image-up.svg?react'),
  'image-upscale': () => import('lucide-static/icons/image-upscale.svg?react'),
  image: () => import('lucide-static/icons/image.svg?react'),
  images: () => import('lucide-static/icons/images.svg?react'),
  import: () => import('lucide-static/icons/import.svg?react'),
  inbox: () => import('lucide-static/icons/inbox.svg?react'),
  'indent-decrease': () => import('lucide-static/icons/indent-decrease.svg?react'),
  'indent-increase': () => import('lucide-static/icons/indent-increase.svg?react'),
  indent: () => import('lucide-static/icons/indent.svg?react'),
  'indian-rupee': () => import('lucide-static/icons/indian-rupee.svg?react'),
  infinity: () => import('lucide-static/icons/infinity.svg?react'),
  info: () => import('lucide-static/icons/info.svg?react'),
  inspect: () => import('lucide-static/icons/inspect.svg?react'),
  'inspection-panel': () => import('lucide-static/icons/inspection-panel.svg?react'),
  instagram: () => import('lucide-static/icons/instagram.svg?react'),
  italic: () => import('lucide-static/icons/italic.svg?react'),
  'iteration-ccw': () => import('lucide-static/icons/iteration-ccw.svg?react'),
  'iteration-cw': () => import('lucide-static/icons/iteration-cw.svg?react'),
  'japanese-yen': () => import('lucide-static/icons/japanese-yen.svg?react'),
  joystick: () => import('lucide-static/icons/joystick.svg?react'),
  'kanban-square-dashed': () => import('lucide-static/icons/kanban-square-dashed.svg?react'),
  'kanban-square': () => import('lucide-static/icons/kanban-square.svg?react'),
  kanban: () => import('lucide-static/icons/kanban.svg?react'),
  kayak: () => import('lucide-static/icons/kayak.svg?react'),
  'key-round': () => import('lucide-static/icons/key-round.svg?react'),
  'key-square': () => import('lucide-static/icons/key-square.svg?react'),
  key: () => import('lucide-static/icons/key.svg?react'),
  'keyboard-music': () => import('lucide-static/icons/keyboard-music.svg?react'),
  'keyboard-off': () => import('lucide-static/icons/keyboard-off.svg?react'),
  keyboard: () => import('lucide-static/icons/keyboard.svg?react'),
  'lamp-ceiling': () => import('lucide-static/icons/lamp-ceiling.svg?react'),
  'lamp-desk': () => import('lucide-static/icons/lamp-desk.svg?react'),
  'lamp-floor': () => import('lucide-static/icons/lamp-floor.svg?react'),
  'lamp-wall-down': () => import('lucide-static/icons/lamp-wall-down.svg?react'),
  'lamp-wall-up': () => import('lucide-static/icons/lamp-wall-up.svg?react'),
  lamp: () => import('lucide-static/icons/lamp.svg?react'),
  'land-plot': () => import('lucide-static/icons/land-plot.svg?react'),
  landmark: () => import('lucide-static/icons/landmark.svg?react'),
  languages: () => import('lucide-static/icons/languages.svg?react'),
  'laptop-2': () => import('lucide-static/icons/laptop-2.svg?react'),
  'laptop-minimal-check': () => import('lucide-static/icons/laptop-minimal-check.svg?react'),
  'laptop-minimal': () => import('lucide-static/icons/laptop-minimal.svg?react'),
  laptop: () => import('lucide-static/icons/laptop.svg?react'),
  'lasso-select': () => import('lucide-static/icons/lasso-select.svg?react'),
  lasso: () => import('lucide-static/icons/lasso.svg?react'),
  laugh: () => import('lucide-static/icons/laugh.svg?react'),
  'layers-2': () => import('lucide-static/icons/layers-2.svg?react'),
  'layers-3': () => import('lucide-static/icons/layers-3.svg?react'),
  'layers-plus': () => import('lucide-static/icons/layers-plus.svg?react'),
  layers: () => import('lucide-static/icons/layers.svg?react'),
  'layout-dashboard': () => import('lucide-static/icons/layout-dashboard.svg?react'),
  'layout-grid': () => import('lucide-static/icons/layout-grid.svg?react'),
  'layout-list': () => import('lucide-static/icons/layout-list.svg?react'),
  'layout-panel-left': () => import('lucide-static/icons/layout-panel-left.svg?react'),
  'layout-panel-top': () => import('lucide-static/icons/layout-panel-top.svg?react'),
  'layout-template': () => import('lucide-static/icons/layout-template.svg?react'),
  layout: () => import('lucide-static/icons/layout.svg?react'),
  leaf: () => import('lucide-static/icons/leaf.svg?react'),
  'leafy-green': () => import('lucide-static/icons/leafy-green.svg?react'),
  lectern: () => import('lucide-static/icons/lectern.svg?react'),
  'letter-text': () => import('lucide-static/icons/letter-text.svg?react'),
  'library-big': () => import('lucide-static/icons/library-big.svg?react'),
  'library-square': () => import('lucide-static/icons/library-square.svg?react'),
  library: () => import('lucide-static/icons/library.svg?react'),
  'life-buoy': () => import('lucide-static/icons/life-buoy.svg?react'),
  ligature: () => import('lucide-static/icons/ligature.svg?react'),
  'lightbulb-off': () => import('lucide-static/icons/lightbulb-off.svg?react'),
  lightbulb: () => import('lucide-static/icons/lightbulb.svg?react'),
  'line-chart': () => import('lucide-static/icons/line-chart.svg?react'),
  'line-squiggle': () => import('lucide-static/icons/line-squiggle.svg?react'),
  'link-2-off': () => import('lucide-static/icons/link-2-off.svg?react'),
  'link-2': () => import('lucide-static/icons/link-2.svg?react'),
  link: () => import('lucide-static/icons/link.svg?react'),
  linkedin: () => import('lucide-static/icons/linkedin.svg?react'),
  'list-check': () => import('lucide-static/icons/list-check.svg?react'),
  'list-checks': () => import('lucide-static/icons/list-checks.svg?react'),
  'list-chevrons-down-up': () => import('lucide-static/icons/list-chevrons-down-up.svg?react'),
  'list-chevrons-up-down': () => import('lucide-static/icons/list-chevrons-up-down.svg?react'),
  'list-collapse': () => import('lucide-static/icons/list-collapse.svg?react'),
  'list-end': () => import('lucide-static/icons/list-end.svg?react'),
  'list-filter-plus': () => import('lucide-static/icons/list-filter-plus.svg?react'),
  'list-filter': () => import('lucide-static/icons/list-filter.svg?react'),
  'list-indent-decrease': () => import('lucide-static/icons/list-indent-decrease.svg?react'),
  'list-indent-increase': () => import('lucide-static/icons/list-indent-increase.svg?react'),
  'list-minus': () => import('lucide-static/icons/list-minus.svg?react'),
  'list-music': () => import('lucide-static/icons/list-music.svg?react'),
  'list-ordered': () => import('lucide-static/icons/list-ordered.svg?react'),
  'list-plus': () => import('lucide-static/icons/list-plus.svg?react'),
  'list-restart': () => import('lucide-static/icons/list-restart.svg?react'),
  'list-start': () => import('lucide-static/icons/list-start.svg?react'),
  'list-todo': () => import('lucide-static/icons/list-todo.svg?react'),
  'list-tree': () => import('lucide-static/icons/list-tree.svg?react'),
  'list-video': () => import('lucide-static/icons/list-video.svg?react'),
  'list-x': () => import('lucide-static/icons/list-x.svg?react'),
  list: () => import('lucide-static/icons/list.svg?react'),
  'loader-2': () => import('lucide-static/icons/loader-2.svg?react'),
  'loader-circle': () => import('lucide-static/icons/loader-circle.svg?react'),
  'loader-pinwheel': () => import('lucide-static/icons/loader-pinwheel.svg?react'),
  loader: () => import('lucide-static/icons/loader.svg?react'),
  'locate-fixed': () => import('lucide-static/icons/locate-fixed.svg?react'),
  'locate-off': () => import('lucide-static/icons/locate-off.svg?react'),
  locate: () => import('lucide-static/icons/locate.svg?react'),
  'location-edit': () => import('lucide-static/icons/location-edit.svg?react'),
  'lock-keyhole-open': () => import('lucide-static/icons/lock-keyhole-open.svg?react'),
  'lock-keyhole': () => import('lucide-static/icons/lock-keyhole.svg?react'),
  'lock-open': () => import('lucide-static/icons/lock-open.svg?react'),
  lock: () => import('lucide-static/icons/lock.svg?react'),
  'log-in': () => import('lucide-static/icons/log-in.svg?react'),
  'log-out': () => import('lucide-static/icons/log-out.svg?react'),
  logs: () => import('lucide-static/icons/logs.svg?react'),
  lollipop: () => import('lucide-static/icons/lollipop.svg?react'),
  luggage: () => import('lucide-static/icons/luggage.svg?react'),
  'm-square': () => import('lucide-static/icons/m-square.svg?react'),
  magnet: () => import('lucide-static/icons/magnet.svg?react'),
  'mail-check': () => import('lucide-static/icons/mail-check.svg?react'),
  'mail-minus': () => import('lucide-static/icons/mail-minus.svg?react'),
  'mail-open': () => import('lucide-static/icons/mail-open.svg?react'),
  'mail-plus': () => import('lucide-static/icons/mail-plus.svg?react'),
  'mail-question-mark': () => import('lucide-static/icons/mail-question-mark.svg?react'),
  'mail-question': () => import('lucide-static/icons/mail-question.svg?react'),
  'mail-search': () => import('lucide-static/icons/mail-search.svg?react'),
  'mail-warning': () => import('lucide-static/icons/mail-warning.svg?react'),
  'mail-x': () => import('lucide-static/icons/mail-x.svg?react'),
  mail: () => import('lucide-static/icons/mail.svg?react'),
  mailbox: () => import('lucide-static/icons/mailbox.svg?react'),
  mails: () => import('lucide-static/icons/mails.svg?react'),
  'map-minus': () => import('lucide-static/icons/map-minus.svg?react'),
  'map-pin-check-inside': () => import('lucide-static/icons/map-pin-check-inside.svg?react'),
  'map-pin-check': () => import('lucide-static/icons/map-pin-check.svg?react'),
  'map-pin-house': () => import('lucide-static/icons/map-pin-house.svg?react'),
  'map-pin-minus-inside': () => import('lucide-static/icons/map-pin-minus-inside.svg?react'),
  'map-pin-minus': () => import('lucide-static/icons/map-pin-minus.svg?react'),
  'map-pin-off': () => import('lucide-static/icons/map-pin-off.svg?react'),
  'map-pin-pen': () => import('lucide-static/icons/map-pin-pen.svg?react'),
  'map-pin-plus-inside': () => import('lucide-static/icons/map-pin-plus-inside.svg?react'),
  'map-pin-plus': () => import('lucide-static/icons/map-pin-plus.svg?react'),
  'map-pin-x-inside': () => import('lucide-static/icons/map-pin-x-inside.svg?react'),
  'map-pin-x': () => import('lucide-static/icons/map-pin-x.svg?react'),
  'map-pin': () => import('lucide-static/icons/map-pin.svg?react'),
  'map-pinned': () => import('lucide-static/icons/map-pinned.svg?react'),
  'map-plus': () => import('lucide-static/icons/map-plus.svg?react'),
  map: () => import('lucide-static/icons/map.svg?react'),
  'mars-stroke': () => import('lucide-static/icons/mars-stroke.svg?react'),
  mars: () => import('lucide-static/icons/mars.svg?react'),
  martini: () => import('lucide-static/icons/martini.svg?react'),
  'maximize-2': () => import('lucide-static/icons/maximize-2.svg?react'),
  maximize: () => import('lucide-static/icons/maximize.svg?react'),
  medal: () => import('lucide-static/icons/medal.svg?react'),
  'megaphone-off': () => import('lucide-static/icons/megaphone-off.svg?react'),
  megaphone: () => import('lucide-static/icons/megaphone.svg?react'),
  meh: () => import('lucide-static/icons/meh.svg?react'),
  'memory-stick': () => import('lucide-static/icons/memory-stick.svg?react'),
  'menu-square': () => import('lucide-static/icons/menu-square.svg?react'),
  menu: () => import('lucide-static/icons/menu.svg?react'),
  merge: () => import('lucide-static/icons/merge.svg?react'),
  'message-circle-code': () => import('lucide-static/icons/message-circle-code.svg?react'),
  'message-circle-dashed': () => import('lucide-static/icons/message-circle-dashed.svg?react'),
  'message-circle-heart': () => import('lucide-static/icons/message-circle-heart.svg?react'),
  'message-circle-more': () => import('lucide-static/icons/message-circle-more.svg?react'),
  'message-circle-off': () => import('lucide-static/icons/message-circle-off.svg?react'),
  'message-circle-plus': () => import('lucide-static/icons/message-circle-plus.svg?react'),
  'message-circle-question-mark': () =>
    import('lucide-static/icons/message-circle-question-mark.svg?react'),
  'message-circle-question': () => import('lucide-static/icons/message-circle-question.svg?react'),
  'message-circle-reply': () => import('lucide-static/icons/message-circle-reply.svg?react'),
  'message-circle-warning': () => import('lucide-static/icons/message-circle-warning.svg?react'),
  'message-circle-x': () => import('lucide-static/icons/message-circle-x.svg?react'),
  'message-circle': () => import('lucide-static/icons/message-circle.svg?react'),
  'message-square-code': () => import('lucide-static/icons/message-square-code.svg?react'),
  'message-square-dashed': () => import('lucide-static/icons/message-square-dashed.svg?react'),
  'message-square-diff': () => import('lucide-static/icons/message-square-diff.svg?react'),
  'message-square-dot': () => import('lucide-static/icons/message-square-dot.svg?react'),
  'message-square-heart': () => import('lucide-static/icons/message-square-heart.svg?react'),
  'message-square-lock': () => import('lucide-static/icons/message-square-lock.svg?react'),
  'message-square-more': () => import('lucide-static/icons/message-square-more.svg?react'),
  'message-square-off': () => import('lucide-static/icons/message-square-off.svg?react'),
  'message-square-plus': () => import('lucide-static/icons/message-square-plus.svg?react'),
  'message-square-quote': () => import('lucide-static/icons/message-square-quote.svg?react'),
  'message-square-reply': () => import('lucide-static/icons/message-square-reply.svg?react'),
  'message-square-share': () => import('lucide-static/icons/message-square-share.svg?react'),
  'message-square-text': () => import('lucide-static/icons/message-square-text.svg?react'),
  'message-square-warning': () => import('lucide-static/icons/message-square-warning.svg?react'),
  'message-square-x': () => import('lucide-static/icons/message-square-x.svg?react'),
  'message-square': () => import('lucide-static/icons/message-square.svg?react'),
  'messages-square': () => import('lucide-static/icons/messages-square.svg?react'),
  'mic-2': () => import('lucide-static/icons/mic-2.svg?react'),
  'mic-off': () => import('lucide-static/icons/mic-off.svg?react'),
  'mic-vocal': () => import('lucide-static/icons/mic-vocal.svg?react'),
  mic: () => import('lucide-static/icons/mic.svg?react'),
  microchip: () => import('lucide-static/icons/microchip.svg?react'),
  microscope: () => import('lucide-static/icons/microscope.svg?react'),
  microwave: () => import('lucide-static/icons/microwave.svg?react'),
  milestone: () => import('lucide-static/icons/milestone.svg?react'),
  'milk-off': () => import('lucide-static/icons/milk-off.svg?react'),
  milk: () => import('lucide-static/icons/milk.svg?react'),
  'minimize-2': () => import('lucide-static/icons/minimize-2.svg?react'),
  minimize: () => import('lucide-static/icons/minimize.svg?react'),
  'minus-circle': () => import('lucide-static/icons/minus-circle.svg?react'),
  'minus-square': () => import('lucide-static/icons/minus-square.svg?react'),
  minus: () => import('lucide-static/icons/minus.svg?react'),
  'monitor-check': () => import('lucide-static/icons/monitor-check.svg?react'),
  'monitor-cloud': () => import('lucide-static/icons/monitor-cloud.svg?react'),
  'monitor-cog': () => import('lucide-static/icons/monitor-cog.svg?react'),
  'monitor-dot': () => import('lucide-static/icons/monitor-dot.svg?react'),
  'monitor-down': () => import('lucide-static/icons/monitor-down.svg?react'),
  'monitor-off': () => import('lucide-static/icons/monitor-off.svg?react'),
  'monitor-pause': () => import('lucide-static/icons/monitor-pause.svg?react'),
  'monitor-play': () => import('lucide-static/icons/monitor-play.svg?react'),
  'monitor-smartphone': () => import('lucide-static/icons/monitor-smartphone.svg?react'),
  'monitor-speaker': () => import('lucide-static/icons/monitor-speaker.svg?react'),
  'monitor-stop': () => import('lucide-static/icons/monitor-stop.svg?react'),
  'monitor-up': () => import('lucide-static/icons/monitor-up.svg?react'),
  'monitor-x': () => import('lucide-static/icons/monitor-x.svg?react'),
  monitor: () => import('lucide-static/icons/monitor.svg?react'),
  'moon-star': () => import('lucide-static/icons/moon-star.svg?react'),
  moon: () => import('lucide-static/icons/moon.svg?react'),
  'more-horizontal': () => import('lucide-static/icons/more-horizontal.svg?react'),
  'more-vertical': () => import('lucide-static/icons/more-vertical.svg?react'),
  motorbike: () => import('lucide-static/icons/motorbike.svg?react'),
  'mountain-snow': () => import('lucide-static/icons/mountain-snow.svg?react'),
  mountain: () => import('lucide-static/icons/mountain.svg?react'),
  'mouse-off': () => import('lucide-static/icons/mouse-off.svg?react'),
  'mouse-pointer-2-off': () => import('lucide-static/icons/mouse-pointer-2-off.svg?react'),
  'mouse-pointer-2': () => import('lucide-static/icons/mouse-pointer-2.svg?react'),
  'mouse-pointer-ban': () => import('lucide-static/icons/mouse-pointer-ban.svg?react'),
  'mouse-pointer-click': () => import('lucide-static/icons/mouse-pointer-click.svg?react'),
  'mouse-pointer-square-dashed': () =>
    import('lucide-static/icons/mouse-pointer-square-dashed.svg?react'),
  'mouse-pointer': () => import('lucide-static/icons/mouse-pointer.svg?react'),
  mouse: () => import('lucide-static/icons/mouse.svg?react'),
  'move-3-d': () => import('lucide-static/icons/move-3-d.svg?react'),
  'move-3d': () => import('lucide-static/icons/move-3d.svg?react'),
  'move-diagonal-2': () => import('lucide-static/icons/move-diagonal-2.svg?react'),
  'move-diagonal': () => import('lucide-static/icons/move-diagonal.svg?react'),
  'move-down-left': () => import('lucide-static/icons/move-down-left.svg?react'),
  'move-down-right': () => import('lucide-static/icons/move-down-right.svg?react'),
  'move-down': () => import('lucide-static/icons/move-down.svg?react'),
  'move-horizontal': () => import('lucide-static/icons/move-horizontal.svg?react'),
  'move-left': () => import('lucide-static/icons/move-left.svg?react'),
  'move-right': () => import('lucide-static/icons/move-right.svg?react'),
  'move-up-left': () => import('lucide-static/icons/move-up-left.svg?react'),
  'move-up-right': () => import('lucide-static/icons/move-up-right.svg?react'),
  'move-up': () => import('lucide-static/icons/move-up.svg?react'),
  'move-vertical': () => import('lucide-static/icons/move-vertical.svg?react'),
  move: () => import('lucide-static/icons/move.svg?react'),
  'music-2': () => import('lucide-static/icons/music-2.svg?react'),
  'music-3': () => import('lucide-static/icons/music-3.svg?react'),
  'music-4': () => import('lucide-static/icons/music-4.svg?react'),
  music: () => import('lucide-static/icons/music.svg?react'),
  'navigation-2-off': () => import('lucide-static/icons/navigation-2-off.svg?react'),
  'navigation-2': () => import('lucide-static/icons/navigation-2.svg?react'),
  'navigation-off': () => import('lucide-static/icons/navigation-off.svg?react'),
  navigation: () => import('lucide-static/icons/navigation.svg?react'),
  network: () => import('lucide-static/icons/network.svg?react'),
  newspaper: () => import('lucide-static/icons/newspaper.svg?react'),
  nfc: () => import('lucide-static/icons/nfc.svg?react'),
  'non-binary': () => import('lucide-static/icons/non-binary.svg?react'),
  'notebook-pen': () => import('lucide-static/icons/notebook-pen.svg?react'),
  'notebook-tabs': () => import('lucide-static/icons/notebook-tabs.svg?react'),
  'notebook-text': () => import('lucide-static/icons/notebook-text.svg?react'),
  notebook: () => import('lucide-static/icons/notebook.svg?react'),
  'notepad-text-dashed': () => import('lucide-static/icons/notepad-text-dashed.svg?react'),
  'notepad-text': () => import('lucide-static/icons/notepad-text.svg?react'),
  'nut-off': () => import('lucide-static/icons/nut-off.svg?react'),
  nut: () => import('lucide-static/icons/nut.svg?react'),
  'octagon-alert': () => import('lucide-static/icons/octagon-alert.svg?react'),
  'octagon-minus': () => import('lucide-static/icons/octagon-minus.svg?react'),
  'octagon-pause': () => import('lucide-static/icons/octagon-pause.svg?react'),
  'octagon-x': () => import('lucide-static/icons/octagon-x.svg?react'),
  octagon: () => import('lucide-static/icons/octagon.svg?react'),
  omega: () => import('lucide-static/icons/omega.svg?react'),
  option: () => import('lucide-static/icons/option.svg?react'),
  orbit: () => import('lucide-static/icons/orbit.svg?react'),
  origami: () => import('lucide-static/icons/origami.svg?react'),
  outdent: () => import('lucide-static/icons/outdent.svg?react'),
  'package-2': () => import('lucide-static/icons/package-2.svg?react'),
  'package-check': () => import('lucide-static/icons/package-check.svg?react'),
  'package-minus': () => import('lucide-static/icons/package-minus.svg?react'),
  'package-open': () => import('lucide-static/icons/package-open.svg?react'),
  'package-plus': () => import('lucide-static/icons/package-plus.svg?react'),
  'package-search': () => import('lucide-static/icons/package-search.svg?react'),
  'package-x': () => import('lucide-static/icons/package-x.svg?react'),
  package: () => import('lucide-static/icons/package.svg?react'),
  'paint-bucket': () => import('lucide-static/icons/paint-bucket.svg?react'),
  'paint-roller': () => import('lucide-static/icons/paint-roller.svg?react'),
  'paintbrush-2': () => import('lucide-static/icons/paintbrush-2.svg?react'),
  'paintbrush-vertical': () => import('lucide-static/icons/paintbrush-vertical.svg?react'),
  paintbrush: () => import('lucide-static/icons/paintbrush.svg?react'),
  palette: () => import('lucide-static/icons/palette.svg?react'),
  palmtree: () => import('lucide-static/icons/palmtree.svg?react'),
  panda: () => import('lucide-static/icons/panda.svg?react'),
  'panel-bottom-close': () => import('lucide-static/icons/panel-bottom-close.svg?react'),
  'panel-bottom-dashed': () => import('lucide-static/icons/panel-bottom-dashed.svg?react'),
  'panel-bottom-inactive': () => import('lucide-static/icons/panel-bottom-inactive.svg?react'),
  'panel-bottom-open': () => import('lucide-static/icons/panel-bottom-open.svg?react'),
  'panel-bottom': () => import('lucide-static/icons/panel-bottom.svg?react'),
  'panel-left-close': () => import('lucide-static/icons/panel-left-close.svg?react'),
  'panel-left-dashed': () => import('lucide-static/icons/panel-left-dashed.svg?react'),
  'panel-left-inactive': () => import('lucide-static/icons/panel-left-inactive.svg?react'),
  'panel-left-open': () => import('lucide-static/icons/panel-left-open.svg?react'),
  'panel-left-right-dashed': () => import('lucide-static/icons/panel-left-right-dashed.svg?react'),
  'panel-left': () => import('lucide-static/icons/panel-left.svg?react'),
  'panel-right-close': () => import('lucide-static/icons/panel-right-close.svg?react'),
  'panel-right-dashed': () => import('lucide-static/icons/panel-right-dashed.svg?react'),
  'panel-right-inactive': () => import('lucide-static/icons/panel-right-inactive.svg?react'),
  'panel-right-open': () => import('lucide-static/icons/panel-right-open.svg?react'),
  'panel-right': () => import('lucide-static/icons/panel-right.svg?react'),
  'panel-top-bottom-dashed': () => import('lucide-static/icons/panel-top-bottom-dashed.svg?react'),
  'panel-top-close': () => import('lucide-static/icons/panel-top-close.svg?react'),
  'panel-top-dashed': () => import('lucide-static/icons/panel-top-dashed.svg?react'),
  'panel-top-inactive': () => import('lucide-static/icons/panel-top-inactive.svg?react'),
  'panel-top-open': () => import('lucide-static/icons/panel-top-open.svg?react'),
  'panel-top': () => import('lucide-static/icons/panel-top.svg?react'),
  'panels-left-bottom': () => import('lucide-static/icons/panels-left-bottom.svg?react'),
  'panels-left-right': () => import('lucide-static/icons/panels-left-right.svg?react'),
  'panels-right-bottom': () => import('lucide-static/icons/panels-right-bottom.svg?react'),
  'panels-top-bottom': () => import('lucide-static/icons/panels-top-bottom.svg?react'),
  'panels-top-left': () => import('lucide-static/icons/panels-top-left.svg?react'),
  paperclip: () => import('lucide-static/icons/paperclip.svg?react'),
  parentheses: () => import('lucide-static/icons/parentheses.svg?react'),
  'parking-circle-off': () => import('lucide-static/icons/parking-circle-off.svg?react'),
  'parking-circle': () => import('lucide-static/icons/parking-circle.svg?react'),
  'parking-meter': () => import('lucide-static/icons/parking-meter.svg?react'),
  'parking-square-off': () => import('lucide-static/icons/parking-square-off.svg?react'),
  'parking-square': () => import('lucide-static/icons/parking-square.svg?react'),
  'party-popper': () => import('lucide-static/icons/party-popper.svg?react'),
  'pause-circle': () => import('lucide-static/icons/pause-circle.svg?react'),
  'pause-octagon': () => import('lucide-static/icons/pause-octagon.svg?react'),
  pause: () => import('lucide-static/icons/pause.svg?react'),
  'paw-print': () => import('lucide-static/icons/paw-print.svg?react'),
  'pc-case': () => import('lucide-static/icons/pc-case.svg?react'),
  'pen-box': () => import('lucide-static/icons/pen-box.svg?react'),
  'pen-line': () => import('lucide-static/icons/pen-line.svg?react'),
  'pen-off': () => import('lucide-static/icons/pen-off.svg?react'),
  'pen-square': () => import('lucide-static/icons/pen-square.svg?react'),
  'pen-tool': () => import('lucide-static/icons/pen-tool.svg?react'),
  pen: () => import('lucide-static/icons/pen.svg?react'),
  'pencil-line': () => import('lucide-static/icons/pencil-line.svg?react'),
  'pencil-off': () => import('lucide-static/icons/pencil-off.svg?react'),
  'pencil-ruler': () => import('lucide-static/icons/pencil-ruler.svg?react'),
  pencil: () => import('lucide-static/icons/pencil.svg?react'),
  pentagon: () => import('lucide-static/icons/pentagon.svg?react'),
  'percent-circle': () => import('lucide-static/icons/percent-circle.svg?react'),
  'percent-diamond': () => import('lucide-static/icons/percent-diamond.svg?react'),
  'percent-square': () => import('lucide-static/icons/percent-square.svg?react'),
  percent: () => import('lucide-static/icons/percent.svg?react'),
  'person-standing': () => import('lucide-static/icons/person-standing.svg?react'),
  'philippine-peso': () => import('lucide-static/icons/philippine-peso.svg?react'),
  'phone-call': () => import('lucide-static/icons/phone-call.svg?react'),
  'phone-forwarded': () => import('lucide-static/icons/phone-forwarded.svg?react'),
  'phone-incoming': () => import('lucide-static/icons/phone-incoming.svg?react'),
  'phone-missed': () => import('lucide-static/icons/phone-missed.svg?react'),
  'phone-off': () => import('lucide-static/icons/phone-off.svg?react'),
  'phone-outgoing': () => import('lucide-static/icons/phone-outgoing.svg?react'),
  phone: () => import('lucide-static/icons/phone.svg?react'),
  'pi-square': () => import('lucide-static/icons/pi-square.svg?react'),
  pi: () => import('lucide-static/icons/pi.svg?react'),
  piano: () => import('lucide-static/icons/piano.svg?react'),
  pickaxe: () => import('lucide-static/icons/pickaxe.svg?react'),
  'picture-in-picture-2': () => import('lucide-static/icons/picture-in-picture-2.svg?react'),
  'picture-in-picture': () => import('lucide-static/icons/picture-in-picture.svg?react'),
  'pie-chart': () => import('lucide-static/icons/pie-chart.svg?react'),
  'piggy-bank': () => import('lucide-static/icons/piggy-bank.svg?react'),
  'pilcrow-left': () => import('lucide-static/icons/pilcrow-left.svg?react'),
  'pilcrow-right': () => import('lucide-static/icons/pilcrow-right.svg?react'),
  'pilcrow-square': () => import('lucide-static/icons/pilcrow-square.svg?react'),
  pilcrow: () => import('lucide-static/icons/pilcrow.svg?react'),
  'pill-bottle': () => import('lucide-static/icons/pill-bottle.svg?react'),
  pill: () => import('lucide-static/icons/pill.svg?react'),
  'pin-off': () => import('lucide-static/icons/pin-off.svg?react'),
  pin: () => import('lucide-static/icons/pin.svg?react'),
  pipette: () => import('lucide-static/icons/pipette.svg?react'),
  pizza: () => import('lucide-static/icons/pizza.svg?react'),
  'plane-landing': () => import('lucide-static/icons/plane-landing.svg?react'),
  'plane-takeoff': () => import('lucide-static/icons/plane-takeoff.svg?react'),
  plane: () => import('lucide-static/icons/plane.svg?react'),
  'play-circle': () => import('lucide-static/icons/play-circle.svg?react'),
  'play-square': () => import('lucide-static/icons/play-square.svg?react'),
  play: () => import('lucide-static/icons/play.svg?react'),
  'plug-2': () => import('lucide-static/icons/plug-2.svg?react'),
  'plug-zap-2': () => import('lucide-static/icons/plug-zap-2.svg?react'),
  'plug-zap': () => import('lucide-static/icons/plug-zap.svg?react'),
  plug: () => import('lucide-static/icons/plug.svg?react'),
  'plus-circle': () => import('lucide-static/icons/plus-circle.svg?react'),
  'plus-square': () => import('lucide-static/icons/plus-square.svg?react'),
  plus: () => import('lucide-static/icons/plus.svg?react'),
  'pocket-knife': () => import('lucide-static/icons/pocket-knife.svg?react'),
  pocket: () => import('lucide-static/icons/pocket.svg?react'),
  podcast: () => import('lucide-static/icons/podcast.svg?react'),
  'pointer-off': () => import('lucide-static/icons/pointer-off.svg?react'),
  pointer: () => import('lucide-static/icons/pointer.svg?react'),
  popcorn: () => import('lucide-static/icons/popcorn.svg?react'),
  popsicle: () => import('lucide-static/icons/popsicle.svg?react'),
  'pound-sterling': () => import('lucide-static/icons/pound-sterling.svg?react'),
  'power-circle': () => import('lucide-static/icons/power-circle.svg?react'),
  'power-off': () => import('lucide-static/icons/power-off.svg?react'),
  'power-square': () => import('lucide-static/icons/power-square.svg?react'),
  power: () => import('lucide-static/icons/power.svg?react'),
  presentation: () => import('lucide-static/icons/presentation.svg?react'),
  'printer-check': () => import('lucide-static/icons/printer-check.svg?react'),
  'printer-x': () => import('lucide-static/icons/printer-x.svg?react'),
  printer: () => import('lucide-static/icons/printer.svg?react'),
  projector: () => import('lucide-static/icons/projector.svg?react'),
  proportions: () => import('lucide-static/icons/proportions.svg?react'),
  puzzle: () => import('lucide-static/icons/puzzle.svg?react'),
  pyramid: () => import('lucide-static/icons/pyramid.svg?react'),
  'qr-code': () => import('lucide-static/icons/qr-code.svg?react'),
  quote: () => import('lucide-static/icons/quote.svg?react'),
  rabbit: () => import('lucide-static/icons/rabbit.svg?react'),
  radar: () => import('lucide-static/icons/radar.svg?react'),
  radiation: () => import('lucide-static/icons/radiation.svg?react'),
  radical: () => import('lucide-static/icons/radical.svg?react'),
  'radio-receiver': () => import('lucide-static/icons/radio-receiver.svg?react'),
  'radio-tower': () => import('lucide-static/icons/radio-tower.svg?react'),
  radio: () => import('lucide-static/icons/radio.svg?react'),
  radius: () => import('lucide-static/icons/radius.svg?react'),
  'rail-symbol': () => import('lucide-static/icons/rail-symbol.svg?react'),
  rainbow: () => import('lucide-static/icons/rainbow.svg?react'),
  rat: () => import('lucide-static/icons/rat.svg?react'),
  ratio: () => import('lucide-static/icons/ratio.svg?react'),
  'receipt-cent': () => import('lucide-static/icons/receipt-cent.svg?react'),
  'receipt-euro': () => import('lucide-static/icons/receipt-euro.svg?react'),
  'receipt-indian-rupee': () => import('lucide-static/icons/receipt-indian-rupee.svg?react'),
  'receipt-japanese-yen': () => import('lucide-static/icons/receipt-japanese-yen.svg?react'),
  'receipt-pound-sterling': () => import('lucide-static/icons/receipt-pound-sterling.svg?react'),
  'receipt-russian-ruble': () => import('lucide-static/icons/receipt-russian-ruble.svg?react'),
  'receipt-swiss-franc': () => import('lucide-static/icons/receipt-swiss-franc.svg?react'),
  'receipt-text': () => import('lucide-static/icons/receipt-text.svg?react'),
  'receipt-turkish-lira': () => import('lucide-static/icons/receipt-turkish-lira.svg?react'),
  receipt: () => import('lucide-static/icons/receipt.svg?react'),
  'rectangle-circle': () => import('lucide-static/icons/rectangle-circle.svg?react'),
  'rectangle-ellipsis': () => import('lucide-static/icons/rectangle-ellipsis.svg?react'),
  'rectangle-goggles': () => import('lucide-static/icons/rectangle-goggles.svg?react'),
  'rectangle-horizontal': () => import('lucide-static/icons/rectangle-horizontal.svg?react'),
  'rectangle-vertical': () => import('lucide-static/icons/rectangle-vertical.svg?react'),
  recycle: () => import('lucide-static/icons/recycle.svg?react'),
  'redo-2': () => import('lucide-static/icons/redo-2.svg?react'),
  'redo-dot': () => import('lucide-static/icons/redo-dot.svg?react'),
  redo: () => import('lucide-static/icons/redo.svg?react'),
  'refresh-ccw-dot': () => import('lucide-static/icons/refresh-ccw-dot.svg?react'),
  'refresh-ccw': () => import('lucide-static/icons/refresh-ccw.svg?react'),
  'refresh-cw-off': () => import('lucide-static/icons/refresh-cw-off.svg?react'),
  'refresh-cw': () => import('lucide-static/icons/refresh-cw.svg?react'),
  refrigerator: () => import('lucide-static/icons/refrigerator.svg?react'),
  regex: () => import('lucide-static/icons/regex.svg?react'),
  'remove-formatting': () => import('lucide-static/icons/remove-formatting.svg?react'),
  'repeat-1': () => import('lucide-static/icons/repeat-1.svg?react'),
  'repeat-2': () => import('lucide-static/icons/repeat-2.svg?react'),
  repeat: () => import('lucide-static/icons/repeat.svg?react'),
  'replace-all': () => import('lucide-static/icons/replace-all.svg?react'),
  replace: () => import('lucide-static/icons/replace.svg?react'),
  'reply-all': () => import('lucide-static/icons/reply-all.svg?react'),
  reply: () => import('lucide-static/icons/reply.svg?react'),
  rewind: () => import('lucide-static/icons/rewind.svg?react'),
  ribbon: () => import('lucide-static/icons/ribbon.svg?react'),
  rocket: () => import('lucide-static/icons/rocket.svg?react'),
  'rocking-chair': () => import('lucide-static/icons/rocking-chair.svg?react'),
  'roller-coaster': () => import('lucide-static/icons/roller-coaster.svg?react'),
  rose: () => import('lucide-static/icons/rose.svg?react'),
  'rotate-3-d': () => import('lucide-static/icons/rotate-3-d.svg?react'),
  'rotate-3d': () => import('lucide-static/icons/rotate-3d.svg?react'),
  'rotate-ccw-key': () => import('lucide-static/icons/rotate-ccw-key.svg?react'),
  'rotate-ccw-square': () => import('lucide-static/icons/rotate-ccw-square.svg?react'),
  'rotate-ccw': () => import('lucide-static/icons/rotate-ccw.svg?react'),
  'rotate-cw-square': () => import('lucide-static/icons/rotate-cw-square.svg?react'),
  'rotate-cw': () => import('lucide-static/icons/rotate-cw.svg?react'),
  'route-off': () => import('lucide-static/icons/route-off.svg?react'),
  route: () => import('lucide-static/icons/route.svg?react'),
  router: () => import('lucide-static/icons/router.svg?react'),
  'rows-2': () => import('lucide-static/icons/rows-2.svg?react'),
  'rows-3': () => import('lucide-static/icons/rows-3.svg?react'),
  'rows-4': () => import('lucide-static/icons/rows-4.svg?react'),
  rows: () => import('lucide-static/icons/rows.svg?react'),
  rss: () => import('lucide-static/icons/rss.svg?react'),
  'ruler-dimension-line': () => import('lucide-static/icons/ruler-dimension-line.svg?react'),
  ruler: () => import('lucide-static/icons/ruler.svg?react'),
  'russian-ruble': () => import('lucide-static/icons/russian-ruble.svg?react'),
  sailboat: () => import('lucide-static/icons/sailboat.svg?react'),
  salad: () => import('lucide-static/icons/salad.svg?react'),
  sandwich: () => import('lucide-static/icons/sandwich.svg?react'),
  'satellite-dish': () => import('lucide-static/icons/satellite-dish.svg?react'),
  satellite: () => import('lucide-static/icons/satellite.svg?react'),
  'saudi-riyal': () => import('lucide-static/icons/saudi-riyal.svg?react'),
  'save-all': () => import('lucide-static/icons/save-all.svg?react'),
  'save-off': () => import('lucide-static/icons/save-off.svg?react'),
  save: () => import('lucide-static/icons/save.svg?react'),
  'scale-3-d': () => import('lucide-static/icons/scale-3-d.svg?react'),
  'scale-3d': () => import('lucide-static/icons/scale-3d.svg?react'),
  scale: () => import('lucide-static/icons/scale.svg?react'),
  scaling: () => import('lucide-static/icons/scaling.svg?react'),
  'scan-barcode': () => import('lucide-static/icons/scan-barcode.svg?react'),
  'scan-eye': () => import('lucide-static/icons/scan-eye.svg?react'),
  'scan-face': () => import('lucide-static/icons/scan-face.svg?react'),
  'scan-heart': () => import('lucide-static/icons/scan-heart.svg?react'),
  'scan-line': () => import('lucide-static/icons/scan-line.svg?react'),
  'scan-qr-code': () => import('lucide-static/icons/scan-qr-code.svg?react'),
  'scan-search': () => import('lucide-static/icons/scan-search.svg?react'),
  'scan-text': () => import('lucide-static/icons/scan-text.svg?react'),
  scan: () => import('lucide-static/icons/scan.svg?react'),
  'scatter-chart': () => import('lucide-static/icons/scatter-chart.svg?react'),
  'school-2': () => import('lucide-static/icons/school-2.svg?react'),
  school: () => import('lucide-static/icons/school.svg?react'),
  'scissors-line-dashed': () => import('lucide-static/icons/scissors-line-dashed.svg?react'),
  'scissors-square-dashed-bottom': () =>
    import('lucide-static/icons/scissors-square-dashed-bottom.svg?react'),
  'scissors-square': () => import('lucide-static/icons/scissors-square.svg?react'),
  scissors: () => import('lucide-static/icons/scissors.svg?react'),
  scooter: () => import('lucide-static/icons/scooter.svg?react'),
  'screen-share-off': () => import('lucide-static/icons/screen-share-off.svg?react'),
  'screen-share': () => import('lucide-static/icons/screen-share.svg?react'),
  'scroll-text': () => import('lucide-static/icons/scroll-text.svg?react'),
  scroll: () => import('lucide-static/icons/scroll.svg?react'),
  'search-alert': () => import('lucide-static/icons/search-alert.svg?react'),
  'search-check': () => import('lucide-static/icons/search-check.svg?react'),
  'search-code': () => import('lucide-static/icons/search-code.svg?react'),
  'search-slash': () => import('lucide-static/icons/search-slash.svg?react'),
  'search-x': () => import('lucide-static/icons/search-x.svg?react'),
  search: () => import('lucide-static/icons/search.svg?react'),
  section: () => import('lucide-static/icons/section.svg?react'),
  'send-horizonal': () => import('lucide-static/icons/send-horizonal.svg?react'),
  'send-horizontal': () => import('lucide-static/icons/send-horizontal.svg?react'),
  'send-to-back': () => import('lucide-static/icons/send-to-back.svg?react'),
  send: () => import('lucide-static/icons/send.svg?react'),
  'separator-horizontal': () => import('lucide-static/icons/separator-horizontal.svg?react'),
  'separator-vertical': () => import('lucide-static/icons/separator-vertical.svg?react'),
  'server-cog': () => import('lucide-static/icons/server-cog.svg?react'),
  'server-crash': () => import('lucide-static/icons/server-crash.svg?react'),
  'server-off': () => import('lucide-static/icons/server-off.svg?react'),
  server: () => import('lucide-static/icons/server.svg?react'),
  'settings-2': () => import('lucide-static/icons/settings-2.svg?react'),
  settings: () => import('lucide-static/icons/settings.svg?react'),
  shapes: () => import('lucide-static/icons/shapes.svg?react'),
  'share-2': () => import('lucide-static/icons/share-2.svg?react'),
  share: () => import('lucide-static/icons/share.svg?react'),
  sheet: () => import('lucide-static/icons/sheet.svg?react'),
  shell: () => import('lucide-static/icons/shell.svg?react'),
  'shield-alert': () => import('lucide-static/icons/shield-alert.svg?react'),
  'shield-ban': () => import('lucide-static/icons/shield-ban.svg?react'),
  'shield-check': () => import('lucide-static/icons/shield-check.svg?react'),
  'shield-close': () => import('lucide-static/icons/shield-close.svg?react'),
  'shield-ellipsis': () => import('lucide-static/icons/shield-ellipsis.svg?react'),
  'shield-half': () => import('lucide-static/icons/shield-half.svg?react'),
  'shield-minus': () => import('lucide-static/icons/shield-minus.svg?react'),
  'shield-off': () => import('lucide-static/icons/shield-off.svg?react'),
  'shield-plus': () => import('lucide-static/icons/shield-plus.svg?react'),
  'shield-question-mark': () => import('lucide-static/icons/shield-question-mark.svg?react'),
  'shield-question': () => import('lucide-static/icons/shield-question.svg?react'),
  'shield-user': () => import('lucide-static/icons/shield-user.svg?react'),
  'shield-x': () => import('lucide-static/icons/shield-x.svg?react'),
  shield: () => import('lucide-static/icons/shield.svg?react'),
  'ship-wheel': () => import('lucide-static/icons/ship-wheel.svg?react'),
  ship: () => import('lucide-static/icons/ship.svg?react'),
  shirt: () => import('lucide-static/icons/shirt.svg?react'),
  'shopping-bag': () => import('lucide-static/icons/shopping-bag.svg?react'),
  'shopping-basket': () => import('lucide-static/icons/shopping-basket.svg?react'),
  'shopping-cart': () => import('lucide-static/icons/shopping-cart.svg?react'),
  shovel: () => import('lucide-static/icons/shovel.svg?react'),
  'shower-head': () => import('lucide-static/icons/shower-head.svg?react'),
  shredder: () => import('lucide-static/icons/shredder.svg?react'),
  shrimp: () => import('lucide-static/icons/shrimp.svg?react'),
  shrink: () => import('lucide-static/icons/shrink.svg?react'),
  shrub: () => import('lucide-static/icons/shrub.svg?react'),
  shuffle: () => import('lucide-static/icons/shuffle.svg?react'),
  'sidebar-close': () => import('lucide-static/icons/sidebar-close.svg?react'),
  'sidebar-open': () => import('lucide-static/icons/sidebar-open.svg?react'),
  sidebar: () => import('lucide-static/icons/sidebar.svg?react'),
  'sigma-square': () => import('lucide-static/icons/sigma-square.svg?react'),
  sigma: () => import('lucide-static/icons/sigma.svg?react'),
  'signal-high': () => import('lucide-static/icons/signal-high.svg?react'),
  'signal-low': () => import('lucide-static/icons/signal-low.svg?react'),
  'signal-medium': () => import('lucide-static/icons/signal-medium.svg?react'),
  'signal-zero': () => import('lucide-static/icons/signal-zero.svg?react'),
  signal: () => import('lucide-static/icons/signal.svg?react'),
  signature: () => import('lucide-static/icons/signature.svg?react'),
  'signpost-big': () => import('lucide-static/icons/signpost-big.svg?react'),
  signpost: () => import('lucide-static/icons/signpost.svg?react'),
  siren: () => import('lucide-static/icons/siren.svg?react'),
  'skip-back': () => import('lucide-static/icons/skip-back.svg?react'),
  'skip-forward': () => import('lucide-static/icons/skip-forward.svg?react'),
  skull: () => import('lucide-static/icons/skull.svg?react'),
  slack: () => import('lucide-static/icons/slack.svg?react'),
  'slash-square': () => import('lucide-static/icons/slash-square.svg?react'),
  slash: () => import('lucide-static/icons/slash.svg?react'),
  slice: () => import('lucide-static/icons/slice.svg?react'),
  'sliders-horizontal': () => import('lucide-static/icons/sliders-horizontal.svg?react'),
  'sliders-vertical': () => import('lucide-static/icons/sliders-vertical.svg?react'),
  sliders: () => import('lucide-static/icons/sliders.svg?react'),
  'smartphone-charging': () => import('lucide-static/icons/smartphone-charging.svg?react'),
  'smartphone-nfc': () => import('lucide-static/icons/smartphone-nfc.svg?react'),
  smartphone: () => import('lucide-static/icons/smartphone.svg?react'),
  'smile-plus': () => import('lucide-static/icons/smile-plus.svg?react'),
  smile: () => import('lucide-static/icons/smile.svg?react'),
  snail: () => import('lucide-static/icons/snail.svg?react'),
  snowflake: () => import('lucide-static/icons/snowflake.svg?react'),
  'soap-dispenser-droplet': () => import('lucide-static/icons/soap-dispenser-droplet.svg?react'),
  sofa: () => import('lucide-static/icons/sofa.svg?react'),
  'solar-panel': () => import('lucide-static/icons/solar-panel.svg?react'),
  'sort-asc': () => import('lucide-static/icons/sort-asc.svg?react'),
  'sort-desc': () => import('lucide-static/icons/sort-desc.svg?react'),
  soup: () => import('lucide-static/icons/soup.svg?react'),
  space: () => import('lucide-static/icons/space.svg?react'),
  spade: () => import('lucide-static/icons/spade.svg?react'),
  sparkle: () => import('lucide-static/icons/sparkle.svg?react'),
  sparkles: () => import('lucide-static/icons/sparkles.svg?react'),
  speaker: () => import('lucide-static/icons/speaker.svg?react'),
  speech: () => import('lucide-static/icons/speech.svg?react'),
  'spell-check-2': () => import('lucide-static/icons/spell-check-2.svg?react'),
  'spell-check': () => import('lucide-static/icons/spell-check.svg?react'),
  'spline-pointer': () => import('lucide-static/icons/spline-pointer.svg?react'),
  spline: () => import('lucide-static/icons/spline.svg?react'),
  'split-square-horizontal': () => import('lucide-static/icons/split-square-horizontal.svg?react'),
  'split-square-vertical': () => import('lucide-static/icons/split-square-vertical.svg?react'),
  split: () => import('lucide-static/icons/split.svg?react'),
  spool: () => import('lucide-static/icons/spool.svg?react'),
  spotlight: () => import('lucide-static/icons/spotlight.svg?react'),
  'spray-can': () => import('lucide-static/icons/spray-can.svg?react'),
  sprout: () => import('lucide-static/icons/sprout.svg?react'),
  'square-activity': () => import('lucide-static/icons/square-activity.svg?react'),
  'square-arrow-down-left': () => import('lucide-static/icons/square-arrow-down-left.svg?react'),
  'square-arrow-down-right': () => import('lucide-static/icons/square-arrow-down-right.svg?react'),
  'square-arrow-down': () => import('lucide-static/icons/square-arrow-down.svg?react'),
  'square-arrow-left': () => import('lucide-static/icons/square-arrow-left.svg?react'),
  'square-arrow-out-down-left': () =>
    import('lucide-static/icons/square-arrow-out-down-left.svg?react'),
  'square-arrow-out-down-right': () =>
    import('lucide-static/icons/square-arrow-out-down-right.svg?react'),
  'square-arrow-out-up-left': () =>
    import('lucide-static/icons/square-arrow-out-up-left.svg?react'),
  'square-arrow-out-up-right': () =>
    import('lucide-static/icons/square-arrow-out-up-right.svg?react'),
  'square-arrow-right': () => import('lucide-static/icons/square-arrow-right.svg?react'),
  'square-arrow-up-left': () => import('lucide-static/icons/square-arrow-up-left.svg?react'),
  'square-arrow-up-right': () => import('lucide-static/icons/square-arrow-up-right.svg?react'),
  'square-arrow-up': () => import('lucide-static/icons/square-arrow-up.svg?react'),
  'square-asterisk': () => import('lucide-static/icons/square-asterisk.svg?react'),
  'square-bottom-dashed-scissors': () =>
    import('lucide-static/icons/square-bottom-dashed-scissors.svg?react'),
  'square-chart-gantt': () => import('lucide-static/icons/square-chart-gantt.svg?react'),
  'square-check-big': () => import('lucide-static/icons/square-check-big.svg?react'),
  'square-check': () => import('lucide-static/icons/square-check.svg?react'),
  'square-chevron-down': () => import('lucide-static/icons/square-chevron-down.svg?react'),
  'square-chevron-left': () => import('lucide-static/icons/square-chevron-left.svg?react'),
  'square-chevron-right': () => import('lucide-static/icons/square-chevron-right.svg?react'),
  'square-chevron-up': () => import('lucide-static/icons/square-chevron-up.svg?react'),
  'square-code': () => import('lucide-static/icons/square-code.svg?react'),
  'square-dashed-bottom-code': () =>
    import('lucide-static/icons/square-dashed-bottom-code.svg?react'),
  'square-dashed-bottom': () => import('lucide-static/icons/square-dashed-bottom.svg?react'),
  'square-dashed-kanban': () => import('lucide-static/icons/square-dashed-kanban.svg?react'),
  'square-dashed-mouse-pointer': () =>
    import('lucide-static/icons/square-dashed-mouse-pointer.svg?react'),
  'square-dashed-top-solid': () => import('lucide-static/icons/square-dashed-top-solid.svg?react'),
  'square-dashed': () => import('lucide-static/icons/square-dashed.svg?react'),
  'square-divide': () => import('lucide-static/icons/square-divide.svg?react'),
  'square-dot': () => import('lucide-static/icons/square-dot.svg?react'),
  'square-equal': () => import('lucide-static/icons/square-equal.svg?react'),
  'square-function': () => import('lucide-static/icons/square-function.svg?react'),
  'square-gantt-chart': () => import('lucide-static/icons/square-gantt-chart.svg?react'),
  'square-kanban': () => import('lucide-static/icons/square-kanban.svg?react'),
  'square-library': () => import('lucide-static/icons/square-library.svg?react'),
  'square-m': () => import('lucide-static/icons/square-m.svg?react'),
  'square-menu': () => import('lucide-static/icons/square-menu.svg?react'),
  'square-minus': () => import('lucide-static/icons/square-minus.svg?react'),
  'square-mouse-pointer': () => import('lucide-static/icons/square-mouse-pointer.svg?react'),
  'square-parking-off': () => import('lucide-static/icons/square-parking-off.svg?react'),
  'square-parking': () => import('lucide-static/icons/square-parking.svg?react'),
  'square-pause': () => import('lucide-static/icons/square-pause.svg?react'),
  'square-pen': () => import('lucide-static/icons/square-pen.svg?react'),
  'square-percent': () => import('lucide-static/icons/square-percent.svg?react'),
  'square-pi': () => import('lucide-static/icons/square-pi.svg?react'),
  'square-pilcrow': () => import('lucide-static/icons/square-pilcrow.svg?react'),
  'square-play': () => import('lucide-static/icons/square-play.svg?react'),
  'square-plus': () => import('lucide-static/icons/square-plus.svg?react'),
  'square-power': () => import('lucide-static/icons/square-power.svg?react'),
  'square-radical': () => import('lucide-static/icons/square-radical.svg?react'),
  'square-round-corner': () => import('lucide-static/icons/square-round-corner.svg?react'),
  'square-scissors': () => import('lucide-static/icons/square-scissors.svg?react'),
  'square-sigma': () => import('lucide-static/icons/square-sigma.svg?react'),
  'square-slash': () => import('lucide-static/icons/square-slash.svg?react'),
  'square-split-horizontal': () => import('lucide-static/icons/square-split-horizontal.svg?react'),
  'square-split-vertical': () => import('lucide-static/icons/square-split-vertical.svg?react'),
  'square-square': () => import('lucide-static/icons/square-square.svg?react'),
  'square-stack': () => import('lucide-static/icons/square-stack.svg?react'),
  'square-star': () => import('lucide-static/icons/square-star.svg?react'),
  'square-stop': () => import('lucide-static/icons/square-stop.svg?react'),
  'square-terminal': () => import('lucide-static/icons/square-terminal.svg?react'),
  'square-user-round': () => import('lucide-static/icons/square-user-round.svg?react'),
  'square-user': () => import('lucide-static/icons/square-user.svg?react'),
  'square-x': () => import('lucide-static/icons/square-x.svg?react'),
  square: () => import('lucide-static/icons/square.svg?react'),
  'squares-exclude': () => import('lucide-static/icons/squares-exclude.svg?react'),
  'squares-intersect': () => import('lucide-static/icons/squares-intersect.svg?react'),
  'squares-subtract': () => import('lucide-static/icons/squares-subtract.svg?react'),
  'squares-unite': () => import('lucide-static/icons/squares-unite.svg?react'),
  'squircle-dashed': () => import('lucide-static/icons/squircle-dashed.svg?react'),
  squircle: () => import('lucide-static/icons/squircle.svg?react'),
  squirrel: () => import('lucide-static/icons/squirrel.svg?react'),
  stamp: () => import('lucide-static/icons/stamp.svg?react'),
  'star-half': () => import('lucide-static/icons/star-half.svg?react'),
  'star-off': () => import('lucide-static/icons/star-off.svg?react'),
  star: () => import('lucide-static/icons/star.svg?react'),
  stars: () => import('lucide-static/icons/stars.svg?react'),
  'step-back': () => import('lucide-static/icons/step-back.svg?react'),
  'step-forward': () => import('lucide-static/icons/step-forward.svg?react'),
  stethoscope: () => import('lucide-static/icons/stethoscope.svg?react'),
  sticker: () => import('lucide-static/icons/sticker.svg?react'),
  'sticky-note': () => import('lucide-static/icons/sticky-note.svg?react'),
  stone: () => import('lucide-static/icons/stone.svg?react'),
  'stop-circle': () => import('lucide-static/icons/stop-circle.svg?react'),
  store: () => import('lucide-static/icons/store.svg?react'),
  'stretch-horizontal': () => import('lucide-static/icons/stretch-horizontal.svg?react'),
  'stretch-vertical': () => import('lucide-static/icons/stretch-vertical.svg?react'),
  strikethrough: () => import('lucide-static/icons/strikethrough.svg?react'),
  subscript: () => import('lucide-static/icons/subscript.svg?react'),
  subtitles: () => import('lucide-static/icons/subtitles.svg?react'),
  'sun-dim': () => import('lucide-static/icons/sun-dim.svg?react'),
  'sun-medium': () => import('lucide-static/icons/sun-medium.svg?react'),
  'sun-moon': () => import('lucide-static/icons/sun-moon.svg?react'),
  'sun-snow': () => import('lucide-static/icons/sun-snow.svg?react'),
  sun: () => import('lucide-static/icons/sun.svg?react'),
  sunrise: () => import('lucide-static/icons/sunrise.svg?react'),
  sunset: () => import('lucide-static/icons/sunset.svg?react'),
  superscript: () => import('lucide-static/icons/superscript.svg?react'),
  'swatch-book': () => import('lucide-static/icons/swatch-book.svg?react'),
  'swiss-franc': () => import('lucide-static/icons/swiss-franc.svg?react'),
  'switch-camera': () => import('lucide-static/icons/switch-camera.svg?react'),
  sword: () => import('lucide-static/icons/sword.svg?react'),
  swords: () => import('lucide-static/icons/swords.svg?react'),
  syringe: () => import('lucide-static/icons/syringe.svg?react'),
  'table-2': () => import('lucide-static/icons/table-2.svg?react'),
  'table-cells-merge': () => import('lucide-static/icons/table-cells-merge.svg?react'),
  'table-cells-split': () => import('lucide-static/icons/table-cells-split.svg?react'),
  'table-columns-split': () => import('lucide-static/icons/table-columns-split.svg?react'),
  'table-config': () => import('lucide-static/icons/table-config.svg?react'),
  'table-of-contents': () => import('lucide-static/icons/table-of-contents.svg?react'),
  'table-properties': () => import('lucide-static/icons/table-properties.svg?react'),
  'table-rows-split': () => import('lucide-static/icons/table-rows-split.svg?react'),
  table: () => import('lucide-static/icons/table.svg?react'),
  'tablet-smartphone': () => import('lucide-static/icons/tablet-smartphone.svg?react'),
  tablet: () => import('lucide-static/icons/tablet.svg?react'),
  tablets: () => import('lucide-static/icons/tablets.svg?react'),
  tag: () => import('lucide-static/icons/tag.svg?react'),
  tags: () => import('lucide-static/icons/tags.svg?react'),
  'tally-1': () => import('lucide-static/icons/tally-1.svg?react'),
  'tally-2': () => import('lucide-static/icons/tally-2.svg?react'),
  'tally-3': () => import('lucide-static/icons/tally-3.svg?react'),
  'tally-4': () => import('lucide-static/icons/tally-4.svg?react'),
  'tally-5': () => import('lucide-static/icons/tally-5.svg?react'),
  tangent: () => import('lucide-static/icons/tangent.svg?react'),
  target: () => import('lucide-static/icons/target.svg?react'),
  telescope: () => import('lucide-static/icons/telescope.svg?react'),
  'tent-tree': () => import('lucide-static/icons/tent-tree.svg?react'),
  tent: () => import('lucide-static/icons/tent.svg?react'),
  'terminal-square': () => import('lucide-static/icons/terminal-square.svg?react'),
  terminal: () => import('lucide-static/icons/terminal.svg?react'),
  'test-tube-2': () => import('lucide-static/icons/test-tube-2.svg?react'),
  'test-tube-diagonal': () => import('lucide-static/icons/test-tube-diagonal.svg?react'),
  'test-tube': () => import('lucide-static/icons/test-tube.svg?react'),
  'test-tubes': () => import('lucide-static/icons/test-tubes.svg?react'),
  'text-align-center': () => import('lucide-static/icons/text-align-center.svg?react'),
  'text-align-end': () => import('lucide-static/icons/text-align-end.svg?react'),
  'text-align-justify': () => import('lucide-static/icons/text-align-justify.svg?react'),
  'text-align-start': () => import('lucide-static/icons/text-align-start.svg?react'),
  'text-cursor-input': () => import('lucide-static/icons/text-cursor-input.svg?react'),
  'text-cursor': () => import('lucide-static/icons/text-cursor.svg?react'),
  'text-initial': () => import('lucide-static/icons/text-initial.svg?react'),
  'text-quote': () => import('lucide-static/icons/text-quote.svg?react'),
  'text-search': () => import('lucide-static/icons/text-search.svg?react'),
  'text-select': () => import('lucide-static/icons/text-select.svg?react'),
  'text-selection': () => import('lucide-static/icons/text-selection.svg?react'),
  'text-wrap': () => import('lucide-static/icons/text-wrap.svg?react'),
  text: () => import('lucide-static/icons/text.svg?react'),
  theater: () => import('lucide-static/icons/theater.svg?react'),
  'thermometer-snowflake': () => import('lucide-static/icons/thermometer-snowflake.svg?react'),
  'thermometer-sun': () => import('lucide-static/icons/thermometer-sun.svg?react'),
  thermometer: () => import('lucide-static/icons/thermometer.svg?react'),
  'thumbs-down': () => import('lucide-static/icons/thumbs-down.svg?react'),
  'thumbs-up': () => import('lucide-static/icons/thumbs-up.svg?react'),
  'ticket-check': () => import('lucide-static/icons/ticket-check.svg?react'),
  'ticket-minus': () => import('lucide-static/icons/ticket-minus.svg?react'),
  'ticket-percent': () => import('lucide-static/icons/ticket-percent.svg?react'),
  'ticket-plus': () => import('lucide-static/icons/ticket-plus.svg?react'),
  'ticket-slash': () => import('lucide-static/icons/ticket-slash.svg?react'),
  'ticket-x': () => import('lucide-static/icons/ticket-x.svg?react'),
  ticket: () => import('lucide-static/icons/ticket.svg?react'),
  'tickets-plane': () => import('lucide-static/icons/tickets-plane.svg?react'),
  tickets: () => import('lucide-static/icons/tickets.svg?react'),
  'timer-off': () => import('lucide-static/icons/timer-off.svg?react'),
  'timer-reset': () => import('lucide-static/icons/timer-reset.svg?react'),
  timer: () => import('lucide-static/icons/timer.svg?react'),
  'toggle-left': () => import('lucide-static/icons/toggle-left.svg?react'),
  'toggle-right': () => import('lucide-static/icons/toggle-right.svg?react'),
  toilet: () => import('lucide-static/icons/toilet.svg?react'),
  'tool-case': () => import('lucide-static/icons/tool-case.svg?react'),
  toolbox: () => import('lucide-static/icons/toolbox.svg?react'),
  tornado: () => import('lucide-static/icons/tornado.svg?react'),
  torus: () => import('lucide-static/icons/torus.svg?react'),
  'touchpad-off': () => import('lucide-static/icons/touchpad-off.svg?react'),
  touchpad: () => import('lucide-static/icons/touchpad.svg?react'),
  'tower-control': () => import('lucide-static/icons/tower-control.svg?react'),
  'toy-brick': () => import('lucide-static/icons/toy-brick.svg?react'),
  tractor: () => import('lucide-static/icons/tractor.svg?react'),
  'traffic-cone': () => import('lucide-static/icons/traffic-cone.svg?react'),
  'train-front-tunnel': () => import('lucide-static/icons/train-front-tunnel.svg?react'),
  'train-front': () => import('lucide-static/icons/train-front.svg?react'),
  'train-track': () => import('lucide-static/icons/train-track.svg?react'),
  train: () => import('lucide-static/icons/train.svg?react'),
  'tram-front': () => import('lucide-static/icons/tram-front.svg?react'),
  transgender: () => import('lucide-static/icons/transgender.svg?react'),
  'trash-2': () => import('lucide-static/icons/trash-2.svg?react'),
  trash: () => import('lucide-static/icons/trash.svg?react'),
  'tree-deciduous': () => import('lucide-static/icons/tree-deciduous.svg?react'),
  'tree-palm': () => import('lucide-static/icons/tree-palm.svg?react'),
  'tree-pine': () => import('lucide-static/icons/tree-pine.svg?react'),
  trees: () => import('lucide-static/icons/trees.svg?react'),
  trello: () => import('lucide-static/icons/trello.svg?react'),
  'trending-down': () => import('lucide-static/icons/trending-down.svg?react'),
  'trending-up-down': () => import('lucide-static/icons/trending-up-down.svg?react'),
  'trending-up': () => import('lucide-static/icons/trending-up.svg?react'),
  'triangle-alert': () => import('lucide-static/icons/triangle-alert.svg?react'),
  'triangle-dashed': () => import('lucide-static/icons/triangle-dashed.svg?react'),
  'triangle-right': () => import('lucide-static/icons/triangle-right.svg?react'),
  triangle: () => import('lucide-static/icons/triangle.svg?react'),
  trophy: () => import('lucide-static/icons/trophy.svg?react'),
  'truck-electric': () => import('lucide-static/icons/truck-electric.svg?react'),
  truck: () => import('lucide-static/icons/truck.svg?react'),
  'turkish-lira': () => import('lucide-static/icons/turkish-lira.svg?react'),
  turntable: () => import('lucide-static/icons/turntable.svg?react'),
  turtle: () => import('lucide-static/icons/turtle.svg?react'),
  'tv-2': () => import('lucide-static/icons/tv-2.svg?react'),
  'tv-minimal-play': () => import('lucide-static/icons/tv-minimal-play.svg?react'),
  'tv-minimal': () => import('lucide-static/icons/tv-minimal.svg?react'),
  tv: () => import('lucide-static/icons/tv.svg?react'),
  twitch: () => import('lucide-static/icons/twitch.svg?react'),
  twitter: () => import('lucide-static/icons/twitter.svg?react'),
  'type-outline': () => import('lucide-static/icons/type-outline.svg?react'),
  type: () => import('lucide-static/icons/type.svg?react'),
  'umbrella-off': () => import('lucide-static/icons/umbrella-off.svg?react'),
  umbrella: () => import('lucide-static/icons/umbrella.svg?react'),
  underline: () => import('lucide-static/icons/underline.svg?react'),
  'undo-2': () => import('lucide-static/icons/undo-2.svg?react'),
  'undo-dot': () => import('lucide-static/icons/undo-dot.svg?react'),
  undo: () => import('lucide-static/icons/undo.svg?react'),
  'unfold-horizontal': () => import('lucide-static/icons/unfold-horizontal.svg?react'),
  'unfold-vertical': () => import('lucide-static/icons/unfold-vertical.svg?react'),
  ungroup: () => import('lucide-static/icons/ungroup.svg?react'),
  university: () => import('lucide-static/icons/university.svg?react'),
  'unlink-2': () => import('lucide-static/icons/unlink-2.svg?react'),
  unlink: () => import('lucide-static/icons/unlink.svg?react'),
  'unlock-keyhole': () => import('lucide-static/icons/unlock-keyhole.svg?react'),
  unlock: () => import('lucide-static/icons/unlock.svg?react'),
  unplug: () => import('lucide-static/icons/unplug.svg?react'),
  'upload-cloud': () => import('lucide-static/icons/upload-cloud.svg?react'),
  upload: () => import('lucide-static/icons/upload.svg?react'),
  usb: () => import('lucide-static/icons/usb.svg?react'),
  'user-2': () => import('lucide-static/icons/user-2.svg?react'),
  'user-check-2': () => import('lucide-static/icons/user-check-2.svg?react'),
  'user-check': () => import('lucide-static/icons/user-check.svg?react'),
  'user-circle-2': () => import('lucide-static/icons/user-circle-2.svg?react'),
  'user-circle': () => import('lucide-static/icons/user-circle.svg?react'),
  'user-cog-2': () => import('lucide-static/icons/user-cog-2.svg?react'),
  'user-cog': () => import('lucide-static/icons/user-cog.svg?react'),
  'user-lock': () => import('lucide-static/icons/user-lock.svg?react'),
  'user-minus-2': () => import('lucide-static/icons/user-minus-2.svg?react'),
  'user-minus': () => import('lucide-static/icons/user-minus.svg?react'),
  'user-pen': () => import('lucide-static/icons/user-pen.svg?react'),
  'user-plus-2': () => import('lucide-static/icons/user-plus-2.svg?react'),
  'user-plus': () => import('lucide-static/icons/user-plus.svg?react'),
  'user-round-check': () => import('lucide-static/icons/user-round-check.svg?react'),
  'user-round-cog': () => import('lucide-static/icons/user-round-cog.svg?react'),
  'user-round-minus': () => import('lucide-static/icons/user-round-minus.svg?react'),
  'user-round-pen': () => import('lucide-static/icons/user-round-pen.svg?react'),
  'user-round-plus': () => import('lucide-static/icons/user-round-plus.svg?react'),
  'user-round-search': () => import('lucide-static/icons/user-round-search.svg?react'),
  'user-round-x': () => import('lucide-static/icons/user-round-x.svg?react'),
  'user-round': () => import('lucide-static/icons/user-round.svg?react'),
  'user-search': () => import('lucide-static/icons/user-search.svg?react'),
  'user-square-2': () => import('lucide-static/icons/user-square-2.svg?react'),
  'user-square': () => import('lucide-static/icons/user-square.svg?react'),
  'user-star': () => import('lucide-static/icons/user-star.svg?react'),
  'user-x-2': () => import('lucide-static/icons/user-x-2.svg?react'),
  'user-x': () => import('lucide-static/icons/user-x.svg?react'),
  user: () => import('lucide-static/icons/user.svg?react'),
  'users-2': () => import('lucide-static/icons/users-2.svg?react'),
  'users-round': () => import('lucide-static/icons/users-round.svg?react'),
  users: () => import('lucide-static/icons/users.svg?react'),
  'utensils-crossed': () => import('lucide-static/icons/utensils-crossed.svg?react'),
  utensils: () => import('lucide-static/icons/utensils.svg?react'),
  'utility-pole': () => import('lucide-static/icons/utility-pole.svg?react'),
  van: () => import('lucide-static/icons/van.svg?react'),
  variable: () => import('lucide-static/icons/variable.svg?react'),
  vault: () => import('lucide-static/icons/vault.svg?react'),
  'vector-square': () => import('lucide-static/icons/vector-square.svg?react'),
  vegan: () => import('lucide-static/icons/vegan.svg?react'),
  'venetian-mask': () => import('lucide-static/icons/venetian-mask.svg?react'),
  'venus-and-mars': () => import('lucide-static/icons/venus-and-mars.svg?react'),
  venus: () => import('lucide-static/icons/venus.svg?react'),
  verified: () => import('lucide-static/icons/verified.svg?react'),
  'vibrate-off': () => import('lucide-static/icons/vibrate-off.svg?react'),
  vibrate: () => import('lucide-static/icons/vibrate.svg?react'),
  'video-off': () => import('lucide-static/icons/video-off.svg?react'),
  video: () => import('lucide-static/icons/video.svg?react'),
  videotape: () => import('lucide-static/icons/videotape.svg?react'),
  view: () => import('lucide-static/icons/view.svg?react'),
  voicemail: () => import('lucide-static/icons/voicemail.svg?react'),
  volleyball: () => import('lucide-static/icons/volleyball.svg?react'),
  'volume-1': () => import('lucide-static/icons/volume-1.svg?react'),
  'volume-2': () => import('lucide-static/icons/volume-2.svg?react'),
  'volume-off': () => import('lucide-static/icons/volume-off.svg?react'),
  'volume-x': () => import('lucide-static/icons/volume-x.svg?react'),
  volume: () => import('lucide-static/icons/volume.svg?react'),
  vote: () => import('lucide-static/icons/vote.svg?react'),
  'wallet-2': () => import('lucide-static/icons/wallet-2.svg?react'),
  'wallet-cards': () => import('lucide-static/icons/wallet-cards.svg?react'),
  'wallet-minimal': () => import('lucide-static/icons/wallet-minimal.svg?react'),
  wallet: () => import('lucide-static/icons/wallet.svg?react'),
  wallpaper: () => import('lucide-static/icons/wallpaper.svg?react'),
  'wand-2': () => import('lucide-static/icons/wand-2.svg?react'),
  'wand-sparkles': () => import('lucide-static/icons/wand-sparkles.svg?react'),
  wand: () => import('lucide-static/icons/wand.svg?react'),
  warehouse: () => import('lucide-static/icons/warehouse.svg?react'),
  'washing-machine': () => import('lucide-static/icons/washing-machine.svg?react'),
  watch: () => import('lucide-static/icons/watch.svg?react'),
  'waves-arrow-down': () => import('lucide-static/icons/waves-arrow-down.svg?react'),
  'waves-arrow-up': () => import('lucide-static/icons/waves-arrow-up.svg?react'),
  'waves-ladder': () => import('lucide-static/icons/waves-ladder.svg?react'),
  waves: () => import('lucide-static/icons/waves.svg?react'),
  waypoints: () => import('lucide-static/icons/waypoints.svg?react'),
  webcam: () => import('lucide-static/icons/webcam.svg?react'),
  'webhook-off': () => import('lucide-static/icons/webhook-off.svg?react'),
  webhook: () => import('lucide-static/icons/webhook.svg?react'),
  'weight-tilde': () => import('lucide-static/icons/weight-tilde.svg?react'),
  weight: () => import('lucide-static/icons/weight.svg?react'),
  'wheat-off': () => import('lucide-static/icons/wheat-off.svg?react'),
  wheat: () => import('lucide-static/icons/wheat.svg?react'),
  'whole-word': () => import('lucide-static/icons/whole-word.svg?react'),
  'wifi-cog': () => import('lucide-static/icons/wifi-cog.svg?react'),
  'wifi-high': () => import('lucide-static/icons/wifi-high.svg?react'),
  'wifi-low': () => import('lucide-static/icons/wifi-low.svg?react'),
  'wifi-off': () => import('lucide-static/icons/wifi-off.svg?react'),
  'wifi-pen': () => import('lucide-static/icons/wifi-pen.svg?react'),
  'wifi-sync': () => import('lucide-static/icons/wifi-sync.svg?react'),
  'wifi-zero': () => import('lucide-static/icons/wifi-zero.svg?react'),
  wifi: () => import('lucide-static/icons/wifi.svg?react'),
  'wind-arrow-down': () => import('lucide-static/icons/wind-arrow-down.svg?react'),
  wind: () => import('lucide-static/icons/wind.svg?react'),
  'wine-off': () => import('lucide-static/icons/wine-off.svg?react'),
  wine: () => import('lucide-static/icons/wine.svg?react'),
  workflow: () => import('lucide-static/icons/workflow.svg?react'),
  worm: () => import('lucide-static/icons/worm.svg?react'),
  'wrap-text': () => import('lucide-static/icons/wrap-text.svg?react'),
  wrench: () => import('lucide-static/icons/wrench.svg?react'),
  'x-circle': () => import('lucide-static/icons/x-circle.svg?react'),
  'x-octagon': () => import('lucide-static/icons/x-octagon.svg?react'),
  'x-square': () => import('lucide-static/icons/x-square.svg?react'),
  x: () => import('lucide-static/icons/x.svg?react'),
  youtube: () => import('lucide-static/icons/youtube.svg?react'),
  'zap-off': () => import('lucide-static/icons/zap-off.svg?react'),
  zap: () => import('lucide-static/icons/zap.svg?react'),
  'zoom-in': () => import('lucide-static/icons/zoom-in.svg?react'),
  'zoom-out': () => import('lucide-static/icons/zoom-out.svg?react'),
}

export type IconName = keyof typeof icons
